(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5235],{

/***/ 97910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconExternal = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M16 12.73V8.285h-.9v4.415a2.402 2.402 0 0 1-2.398 2.4H3.298A2.402 2.402 0 0 1 .9 12.7V3.298A2.402 2.402 0 0 1 3.298.9h4.39V0h-4.39A3.292 3.292 0 0 0 0 3.298v9.404A3.292 3.292 0 0 0 3.298 16h9.404C14.527 16 16 14.527 16 12.73Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15.1 4.825v-3.27L8.068 8.587l-.654-.654L14.447.901h-3.271V0H16v4.824h-.9Z",
  fill: "#B18D3B"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconExternal);

/***/ }),

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMore = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M10.561 16c-.242 0-.477-.084-.665-.24l-6.233-5.043a.681.681 0 0 1-.094-.925.635.635 0 0 1 .894-.125l6.098 4.936 9.166-7.671a.635.635 0 0 1 .912.097.68.68 0 0 1-.096.938l-9.299 7.78a1.052 1.052 0 0 1-.683.253Zm-8.06-6.414a.646.646 0 0 1-.402-.142L.289 7.972a.682.682 0 0 1-.15-.968.635.635 0 0 1 .949-.078l1.815 1.468c.28.23.329.65.109.94a.653.653 0 0 1-.51.252Zm8.29-.369c-.243 0-.477-.084-.667-.24L3.875 3.943a.68.68 0 0 1-.095-.925.635.635 0 0 1 .895-.125l6.115 4.928L19.943.149a.637.637 0 0 1 .912.097.681.681 0 0 1-.095.94l-9.3 7.778c-.19.16-.425.25-.67.253ZM2.716 2.804a.659.659 0 0 1-.402-.142L.505 1.19a.68.68 0 0 1-.07-.903.636.636 0 0 1 .87-.142L3.12 1.612h-.001c.28.23.329.648.108.938a.658.658 0 0 1-.51.254Z",
  fill: "currentcolor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconMore);

/***/ }),

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 98544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addClass; }
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),

/***/ 74277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ removeClass; }
/* harmony export */ });
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),

/***/ 51012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42006);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51524);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34495);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);







var GalleryGrid = function(param) {
    var button = param.button, images = param.images, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    var isDesktop = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__/* .useResponsive */ .F)().isDesktop;
    // Helper function to get image URLs based on Cloudflare variants
    var getImageUrls = function(item) {
        var baseUrl = item.large || item.original || item;
        var isCloudflare = typeof baseUrl === "string" && baseUrl.includes("imagedelivery.net");
        // Use standard size variants for all images since they're all above the fold
        var getVariant = function(size) {
            if (!isCloudflare) return baseUrl;
            return baseUrl.replace(/\/([^/]+)$/, "/".concat(size));
        };
        return {
            small: getVariant("360"),
            medium: getVariant("640"),
            large: getVariant("960")
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__/* .withModifiers */ .i)("gallery", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(variant).concat([
            button && "has-button"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gallery__grid),
                children: images && images.map(function(item, index) {
                    if (!item) return null;
                    var urls = getImageUrls(item);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gallery__item),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                fetchpriority: "high",
                                srcSet: "".concat(urls.small, " 360w,\n                          ").concat(urls.medium, " 640w,\n                          ").concat(urls.large, " 960w,\n                          ").concat(urls.large, " 1980w"),
                                src: urls.large,
                                layout: "fill",
                                priority: true,
                                objectFit: "cover",
                                sizes: "(max-width: 360px) 360px, (max-width: 640px) 640px, (max-width: 960px) 960px, 960px",
                                alt: "Gallery Image ".concat(index),
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gallery__image)
                            }),
                            index === 1 && !isDesktop && button && button
                        ]
                    }, index);
                })
            }),
            isDesktop && button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: button
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GalleryGrid);


/***/ }),

/***/ 54903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_pages_common_Contact_components_ContactForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64150);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17423);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);






var InquiryModal = function(param) {
    var name = param.name, translations = param.translations, form = param.form;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                children: "".concat(translations.popup.title[router.locale], " ").concat(name)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                children: translations.popup.contact[router.locale]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_common_Contact_components_ContactForm__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                translations: translations,
                variant: [
                    "dark"
                ],
                route: "real-estate/contact-email"
            }, form), {
                thankYou: {
                    url: "/real-estate/search"
                }
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InquiryModal);


/***/ }),

/***/ 91647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ getRandom; }
/* harmony export */ });
/* harmony import */ var lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);

var getRandom = function(arr, n) {
    if ((0,lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr)) {
        var result = new Array(n), len = arr.length, taken = new Array(len);
        if (n > len) return;
        while(n--){
            var x = Math.floor(Math.random() * len);
            result[n] = arr[x in taken ? taken[x] : x];
            taken[x] = --len in taken ? taken[len] : len;
        }
        return result;
    }
    return;
};


/***/ }),

/***/ 74102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ single_property_Availability; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/pages/single-property/Availability/components/Dates/index.js







var Calendar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(47), __webpack_require__.e(5474)]).then(__webpack_require__.bind(__webpack_require__, 34705));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34705)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading calendar..."
        });
    }
});
var Dates = function(param) {
    var setFieldValue = param.form.setFieldValue, property = param.property, blockedDates = param.blockedDates, minNights = param.minNights, translations = param.translations;
    var isDesktop = (0,ResponsiveContext/* useResponsive */.F)().isDesktop;
    var ref = (0,SearchContext/* useSearchContext */.AB)(), search = ref.search, setSearch = ref.setSearch, initialValues = ref.initialValues, offsetable = ref.offsetable;
    var ref1 = (0,react.useState)(offsetable === 0 && (search === null || search === void 0 ? void 0 : search.startDate) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.startDate)), startDate = ref1[0], setStartDate = ref1[1];
    var ref2 = (0,react.useState)(offsetable === 0 && (search === null || search === void 0 ? void 0 : search.endDate) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.endDate)), endDate = ref2[0], setEndDate = ref2[1];
    (0,react.useEffect)(function() {
        setStartDate(search.startDate);
        setEndDate(search.endDate);
        setFieldValue("startDate", startDate);
        setFieldValue("endDate", endDate);
    }, [
        search.startDate,
        search.endDate
    ]);
    (0,react.useEffect)(function() {
        setFieldValue("startDate", startDate);
        setFieldValue("endDate", endDate);
        setSearch && setSearch(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                endDate: endDate,
                startDate: startDate
            });
        });
    }, [
        startDate,
        endDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {
        translations: translations,
        variant: [
            "dark",
            "large"
        ],
        setStartDate: setStartDate,
        setEndDate: setEndDate,
        startDate: startDate,
        blockedDates: blockedDates,
        endDate: endDate,
        disabled: !property.is_active,
        minimumNights: minNights,
        clearable: true,
        daySize: isDesktop ? 35 : 41,
        yearJump: true
    });
};
/* harmony default export */ var components_Dates = (Dates);

// EXTERNAL MODULE: ./components/pages/single-property/Availability/styles.module.scss
var styles_module = __webpack_require__(5963);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./providers/authProvider.js
var authProvider = __webpack_require__(89149);
// EXTERNAL MODULE: ./public/icons/icon-external.svg
var icon_external = __webpack_require__(97910);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/index.js + 8 modules
var Card = __webpack_require__(87086);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/single-property/Availability/index.js



















var Availability = function(_param) {
    var bottomRef = _param.bottomRef, property = _param.property, minNights = _param.minNights, title = _param.title, note = _param.note, description = _param.description, variant = _param.variant, translations = _param.translations, cardTranslation = _param.cardTranslation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "bottomRef",
        "property",
        "minNights",
        "title",
        "note",
        "description",
        "variant",
        "translations",
        "cardTranslation"
    ]);
    var ref, ref1, ref2;
    var ref3 = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref3.isTablet, isMobile = ref3.isMobile;
    var isAuthorized = (0,authProvider/* useAuthContext */.Eu)().isAuthorized;
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        variant: variant,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                columnRef: bottomRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                    spans: isMobile ? 12 : isTablet ? 8 : 6,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (styles_module_default()).title,
                            children: title
                        }),
                        note && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).note,
                            children: note
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        minNights && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).nights,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: minNights
                                }),
                                " ",
                                (ref = translations.welcome.card) === null || ref === void 0 ? void 0 : ref.minNights[router.locale]
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).wrapper,
                            children: [
                                isTablet && props.blockedDates && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,withModifiers/* withModifiers */.i)("booking", [
                                        search.startDate && search.endDate && "is-visible"
                                    ], (styles_module_default())),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                        translations: cardTranslation,
                                        variant: [
                                            "simple"
                                        ],
                                        blockedDates: props.blockedDates,
                                        expandable: true,
                                        header: false,
                                        property: property,
                                        minNights: minNights
                                    })
                                }),
                                props.blockedDates && property && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).calendar,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                            initialValues: {
                                                startDate: "",
                                                endDate: ""
                                            },
                                            children: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                                        translations: translations.availability,
                                                        property: property,
                                                        minNights: minNights,
                                                        component: components_Dates
                                                    }))
                                                });
                                            }
                                        }),
                                        isAuthorized && property && (property === null || property === void 0 ? void 0 : (ref1 = property.attachment) === null || ref1 === void 0 ? void 0 : ref1.calendar) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            href: property.attachment.calendar,
                                            appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {}),
                                            target: "_blank",
                                            className: (styles_module_default()).calendar__button,
                                            variant: [
                                                "label"
                                            ],
                                            children: translations === null || translations === void 0 ? void 0 : (ref2 = translations.availability) === null || ref2 === void 0 ? void 0 : ref2.subscribe[router.locale]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var single_property_Availability = (Availability);


/***/ }),

/***/ 12626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ single_property_Details; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./public/icons/icon-bedroom.svg
var icon_bedroom = __webpack_require__(83316);
// EXTERNAL MODULE: ./public/icons/icon-bathroom.svg
var icon_bathroom = __webpack_require__(4818);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-couch.svg
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCouch = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 41 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M4.336 21v3.333M36 21v3.333M1 11v6.667C1 19.507 2.49 21 4.333 21H36a3.334 3.334 0 0 0 3.333-3.333V11",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M34.333 11v1.667c0 .918-.746 1.666-1.666 1.666h-25A1.667 1.667 0 0 1 6 12.667V11M36.003 8.604v-.936A6.665 6.665 0 0 0 29.336 1H11.003a6.664 6.664 0 0 0-6.667 6.667v.961",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M1 11c0-1.383 1.118-2.5 2.5-2.5C4.88 8.5 6 9.617 6 11M39.336 11c0-1.383-1.12-2.5-2.5-2.5a2.498 2.498 0 0 0-2.5 2.5M19.336 1v13.333",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_couch = (SvgIconCouch);
// EXTERNAL MODULE: ./components/pages/single-property/components/Perk/index.js
var Perk = __webpack_require__(1962);
// EXTERNAL MODULE: ./components/pages/single-property/Details/styles.module.scss
var styles_module = __webpack_require__(75885);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./public/icons/icon-more.svg
var icon_more = __webpack_require__(38875);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/single-property/Details/index.js

















var Details = function(param) {
    var bedrooms = param.bedrooms, bathrooms = param.bathrooms, common_areas = param.common_areas, more_information = param.more_information, _title = param.title, title = _title === void 0 ? false : _title, translations = param.translations;
    var router = (0,next_router.useRouter)();
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isDesktop = ref.isDesktop, isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var items = !show ? 3 : 99;
    if ((0,isEmpty/* default */.Z)(bedrooms) && (0,isEmpty/* default */.Z)(bathrooms) && (0,isEmpty/* default */.Z)(common_areas) && (0,isEmpty/* default */.Z)(more_information)) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        className: (styles_module_default()).section,
        variant: [
            "white",
            "p-xl"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                variant: [
                    "-distribute-between"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                    variant: [
                        isDesktop && !isSmallMobile && "-pr0"
                    ],
                    spans: isTablet ? 12 : 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title || (translations === null || translations === void 0 ? void 0 : translations.title[router.locale])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).content,
                            children: [
                                bedrooms && (bedrooms === null || bedrooms === void 0 ? void 0 : bedrooms.map(function(item, index) {
                                    return index < items && /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk/* default */.Z, (0,_object_spread/* default */.Z)({
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bedroom/* default */.Z, {
                                            width: 40,
                                            height: 28
                                        })
                                    }, item), "bedroom-key-".concat(index));
                                })),
                                more_information && (more_information === null || more_information === void 0 ? void 0 : more_information.map(function(item, index) {
                                    return index < items && /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk/* default */.Z, (0,_object_spread/* default */.Z)({}, item), "bedroom-key-".concat(index));
                                })),
                                items < (bedrooms === null || bedrooms === void 0 ? void 0 : bedrooms.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                    onClick: function() {
                                        return setShow(true);
                                    },
                                    appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_more/* default */.Z, {
                                        width: 21
                                    }),
                                    arrow: false,
                                    variant: [
                                        "label",
                                        "color-primary",
                                        "m-t-xl"
                                    ],
                                    children: translations === null || translations === void 0 ? void 0 : translations.bedroomOptions[router.locale]
                                }),
                                bedrooms && bathrooms && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).separator
                                }),
                                bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.map(function(bathroom, index) {
                                    return (bathroom.value || bathroom.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk/* default */.Z, (0,_object_spread/* default */.Z)({
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bathroom/* default */.Z, {
                                            width: 40,
                                            height: 28
                                        })
                                    }, bathroom), "bathroom-".concat(index));
                                }),
                                common_areas && /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk/* default */.Z, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_couch, {
                                        width: 40,
                                        height: 28
                                    }),
                                    value: translations === null || translations === void 0 ? void 0 : translations.commonArea[router.locale],
                                    title: common_areas
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var single_property_Details = (Details);


/***/ }),

/***/ 44731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ single_property_Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/pages/single-property/Gallery/styles.module.scss
var styles_module = __webpack_require__(65792);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-gallery.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconGallery = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 37 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m34.272 8.886-1.141 5.427 2.693 1.868c.187.13.232.386.101.57l-4.708 6.67-.983 4.675a.413.413 0 0 1-.488.316l-1.789-.369-3.379 4.782a.415.415 0 0 1-.575.1l-11.698-8.11-5.16-1.064-3.331.395a.425.425 0 0 1-.46-.359L1.003 4.31a.412.412 0 0 1 .362-.456l24.059-2.85a.413.413 0 0 1 .46.358l.665 5.52 7.402 1.522a.407.407 0 0 1 .32.483ZM14.359 25.24l9.78 6.78 2.936-4.157L14.36 25.24Zm4.777-3.735 8.226-.975-.427-3.536-7.808-8.408-4.933 7.6 4.942 5.32ZM4.586 23.23l13.537-1.604-7.36-7.92-6.176 9.524Zm22.182-7.622-.374-3.1-1.282-10.643L1.874 4.618 4.04 22.56l6.319-9.74a.414.414 0 0 1 .651-.057l2.606 2.803 5.106-7.867a.413.413 0 0 1 .651-.057l7.394 7.961a11.991 11.991 0 0 1-.008-.068l.009.072Zm-17.042 7.84 19.783 4.08c.686-3.258 2.299-10.934 3.312-15.755l.557-2.652-6.725-1.381 1.581 13.1a.415.415 0 0 1-.365.457l-18.143 2.15Zm23.222-8.26-1.303 6.197 3.365-4.768-2.062-1.43Zm-16.947-.054 2.776-4.275a.413.413 0 0 1 .572-.123.408.408 0 0 1 .123.566l-2.776 4.276a.416.416 0 0 1-.571.122.408.408 0 0 1-.124-.566ZM9.384 17.57l-.834 1.284a.408.408 0 0 0 .124.566c.187.121.446.07.57-.122l.834-1.284a1.346 1.346 0 0 1 2.112-.181l.918.987a.414.414 0 0 0 .583.024.406.406 0 0 0 .024-.578l-.918-.987c-.955-1.032-2.645-.896-3.413.291Zm-1.97-7.172a1.748 1.748 0 0 1-1.74-1.53 1.742 1.742 0 0 1 1.533-1.932 1.751 1.751 0 0 1 1.949 1.519 1.742 1.742 0 0 1-1.742 1.943Zm.92-1.846a.924.924 0 0 0-1.029-.802.918.918 0 1 0 .22 1.822.921.921 0 0 0 .81-1.02Zm-1.242-2.16c.252 0 .44-.216.412-.458l-.106-.872a.415.415 0 0 0-.46-.359.412.412 0 0 0-.361.456l.106.872a.41.41 0 0 0 .41.361Zm-1.491.854a.415.415 0 0 1-.58.069l-.697-.542a.406.406 0 0 1-.07-.575.418.418 0 0 1 .58-.069l.697.542c.18.14.211.398.07.575Zm-.84 2.14a.41.41 0 0 0 .361-.455.419.419 0 0 0-.46-.359l-.88.105a.41.41 0 0 0-.361.455.412.412 0 0 0 .46.359l.88-.105Zm.1 1.831.546-.69c.142-.177.401-.209.58-.068.18.14.211.397.07.574l-.547.69a.415.415 0 0 1-.58.07.407.407 0 0 1-.07-.576Zm2.826-.285a.41.41 0 0 0-.362.456l.106.872c.025.209.203.361.41.361.25 0 .44-.216.411-.458l-.105-.873a.417.417 0 0 0-.46-.358Zm1.542-.857a.415.415 0 0 1 .58-.069l.697.542c.18.14.21.398.07.575a.415.415 0 0 1-.581.07l-.696-.543a.407.407 0 0 1-.07-.575Zm.475-1.685c.056.462.54.375.948.302a2.09 2.09 0 0 1 .392-.048.412.412 0 0 0 .361-.456.416.416 0 0 0-.46-.358l-.88.105a.413.413 0 0 0-.361.455Zm.267-2.284-.547.69a.418.418 0 0 1-.58.068.406.406 0 0 1-.07-.575l.547-.69c.142-.177.4-.209.58-.068.18.139.212.397.07.575Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "m33.131 14.313-.196-.04-.027.129.109.076.114-.165Zm1.14-5.427-.195-.041.196.041Zm1.553 7.295.114-.164-.114.164Zm.101.57-.163-.115.163.116Zm-4.708 6.67-.163-.115-.024.034-.009.04.196.041Zm-.983 4.675.196.041-.196-.041Zm-.488.316.04-.196-.04.196Zm-1.789-.369.04-.195-.128-.027-.075.107.163.115Zm-3.379 4.782-.163-.115.163.115Zm-.575.1.114-.163v-.001l-.114.164Zm-11.698-8.11.114-.165-.034-.023-.04-.008-.04.196Zm-5.16-1.064.04-.196-.032-.006-.032.004.023.198Zm-3.331.395.02.199h.003l-.023-.2Zm-.46-.359-.199.024.199-.024ZM1.003 4.31l.199-.024-.199.024Zm.362-.456-.024-.198.024.198Zm24.059-2.85-.022-.2-.002.001.024.199Zm.304.085.123-.158-.123.158Zm.155.273.199-.024v-.001l-.199.025Zm.666 5.52-.198.024.017.143.141.029.04-.196Zm7.402 1.522-.04.195h.002l.038-.195Zm.262.176-.167.11.001.001.166-.111ZM24.138 32.02l-.114.165.163.113.114-.162-.163-.116Zm-9.78-6.78.04-.195-.153.36.114-.165Zm12.717 2.623.164.115.176-.25-.3-.061-.04.196Zm.287-7.333.023.199.2-.024-.025-.199-.198.024Zm-8.226.975-.146.136.069.075.1-.012-.023-.199Zm7.8-4.511.198-.024-.008-.065-.044-.047-.147.136Zm-7.809-8.408.146-.136-.174-.188-.14.215.168.109Zm-4.933 7.6-.167-.11-.085.132.106.114.146-.136Zm3.93 5.439.023.198.391-.046-.268-.289-.146.137ZM4.586 23.229l-.168-.11-.232.358.423-.05-.023-.198Zm6.176-9.524.146-.136-.174-.188-.14.215.168.11Zm15.631-1.199-.198.024.198-.024Zm.374 3.1-.199.025.024.197.198-.022-.023-.2ZM25.112 1.865l.198-.024-.024-.198-.198.023.024.199ZM1.874 4.618l-.023-.199-.2.024.025.199.198-.024ZM4.04 22.56l-.199.024.066.547.3-.462-.167-.11Zm6.319-9.74-.167-.11.167.11Zm.312-.187-.016-.2.016.2Zm.34.13.146-.136-.002-.001-.145.137Zm2.605 2.803-.147.136.175.188.14-.215-.168-.109Zm5.106-7.867.168.109-.168-.11Zm.312-.187.016.2h.002l-.018-.2Zm.339.13.146-.136v-.001l-.146.137Zm7.393 7.961-.146.136.418.45-.073-.61-.198.024Zm-.007-.068-.199.024.002.009.197-.033Zm0 0 .199-.024-.002-.009-.197.033Zm2.75 11.991-.04.196.02.004h.02v-.2Zm-19.783-4.08-.024-.198-.017.394.04-.196Zm19.783 4.08v.2h.163l.033-.158-.196-.042Zm3.312-15.754-.196-.041.196.04Zm.557-2.652.196.041.041-.196-.197-.04-.04.195ZM26.653 7.74l.04-.196-.272-.056.034.276.198-.024Zm1.581 13.1.199-.024-.199.024Zm-.365.457.024.198-.024-.198Zm3.776.088-.196-.041.36.157-.164-.116Zm1.303-6.197.114-.165-.247-.171-.062.294.195.042Zm2.062 1.429.163.115.117-.165-.166-.115-.114.165Zm-16.233-5.758.168.108-.168-.108Zm-2.776 4.275.168.11-.168-.11Zm3.348-4.398-.11.168h.002l.108-.168Zm.123.566-.167-.109.167.11Zm-2.776 4.276.168.109-.168-.11Zm-.571.122.109-.168h-.001l-.108.168ZM8.55 18.854l.168.11-.168-.11Zm.834-1.284.196-.04-.097-.481-.267.412.168.109Zm-.71 1.85.108-.168-.108.168Zm.57-.122.169.109-.168-.11Zm.834-1.284.168.108-.168-.108Zm2.112-.181.146-.136-.146.136Zm.918.987.146-.136-.146.136Zm.583.024-.135-.148-.001.001.136.147Zm.024-.578-.146.136.146-.136Zm-.918-.987-.147.136.147-.136Zm-3.413.291-.197.04.097.482.267-.413-.167-.109Zm-3.71-8.703.2-.024-.006-.042-.022-.037-.171.103Zm0 0-.198.024.005.042.022.037.172-.103Zm1.533-1.93-.022-.2h-.001l.023.2Zm1.949 1.518-.199.024.199-.024Zm-1.533 1.93.021.2h.003l-.024-.2ZM7.305 7.75l.024.199h.001l-.025-.199Zm1.03.802.198-.024-.198.024Zm-1.84.218-.198.024.199-.024Zm1.03.802-.023-.199H7.5l.025.2Zm-.021-3.638.199-.024-.2.024Zm-.412.458v-.2h-.2v.2h.2Zm.306-1.33.199-.024-.199.024Zm-.46-.359-.019-.199h-.004l.024.2Zm-.361.456.199-.024-.199.024Zm.106.872.198-.023v-.001l-.198.024Zm.41.361v.2h.2v-.2h-.2Zm-2.073.923-.123.158.123-.158Zm.58-.069.157.125-.156-.125Zm-1.276-.473.123-.158-.123.158Zm-.07-.575L4.1 6.073l.156.125Zm.58-.069.124-.158-.123.158Zm.697.542-.123.158.123-.158Zm-.409 2.26-.198.024.198-.024Zm-.361.455-.024-.198.024.198Zm-.098-.814-.02-.199h-.004l.024.2Zm-.88.105.023.199-.023-.199Zm-.362.455.199-.024-.2.024Zm.46.359.019.199h.004l-.023-.2Zm1.526 1.036-.156-.124.156.124Zm-.547.69.157.125-.157-.125Zm1.197-.184L5.9 10.91l.157.124Zm-.547.69.156.125-.156-.125Zm-.58.07-.124.157.123-.158Zm2.395-.405.199-.024-.199.024Zm.362-.456-.021-.199h-.003l.024.2ZM7.43 12.26l-.199.024.199-.024Zm.821-.097.199-.024-.199.024Zm-.105-.873-.199.024.199-.024Zm1.663-1.284.122-.157-.122.157Zm-.58.069.156.125-.157-.125Zm1.276.473.123-.157-.123.157Zm.07.575.155.125-.156-.125Zm-.581.07-.123.157.123-.158Zm-.696-.543-.124.157.124-.157Zm1.353-1.958.035.197-.035-.197Zm-.948-.302v-.2h-.226l.027.224.199-.024Zm1.34.254-.007.2h.015l.015-.001-.023-.2Zm.361-.456.199-.024-.199.024Zm-.46-.358-.018-.2-.005.001.024.199Zm-.88.105-.023-.2.024.2Zm-.361.455v.2h.224l-.025-.223-.2.023Zm-.28-1.594.156.125V6.92l-.156-.124Zm.547-.69-.157-.125.157.125Zm-1.197.183.157.125-.157-.125Zm.547-.69-.156-.124.156.124Zm.58-.068-.122.158.123-.158Zm23.426 8.823 1.14-5.426-.39-.083-1.142 5.427.392.082Zm2.611 1.663-2.693-1.868-.228.329 2.693 1.868.228-.33Zm.15.85a.607.607 0 0 0-.15-.85l-.228.329a.207.207 0 0 1 .052.29l.326.231Zm-4.708 6.67 4.708-6.67-.326-.23-4.709 6.669.327.23Zm-.95 4.6.983-4.675-.392-.082-.982 4.675.391.082Zm-.6.484a.613.613 0 0 0 .6-.484l-.391-.083a.213.213 0 0 1-.209.167v.4Zm-.125-.013a.62.62 0 0 0 .125.013v-.4a.218.218 0 0 1-.043-.005l-.082.392Zm-1.788-.369 1.789.37.08-.393-1.789-.369-.08.392Zm-3.176 4.702 3.38-4.782-.327-.231-3.38 4.782.327.23Zm-.502.259c.191 0 .383-.09.503-.26l-.327-.23a.215.215 0 0 1-.176.09v.4Zm-.351-.111a.607.607 0 0 0 .351.111v-.4a.207.207 0 0 1-.122-.038l-.23.327Zm-11.697-8.11 11.697 8.11.228-.328-11.697-8.11-.228.328Zm-5.087-1.032 5.16 1.064.081-.392-5.16-1.064-.081.392Zm-3.267.397 3.33-.394-.046-.397-3.33.394.046.397Zm-.682-.533c.04.32.344.567.678.534l-.039-.398c-.121.012-.23-.083-.241-.184l-.398.048ZM.805 4.333l2.35 19.478.398-.048L1.202 4.285l-.398.048Zm.536-.678a.612.612 0 0 0-.537.678l.397-.048a.212.212 0 0 1 .187-.233l-.047-.397ZM25.401.804 1.34 3.654l.047.398 24.06-2.85L25.4.803Zm.45.126a.62.62 0 0 0-.45-.126l.044.397a.22.22 0 0 1 .16.044L25.85.93Zm.23.406a.613.613 0 0 0-.23-.406l-.246.315a.213.213 0 0 1 .08.141l.397-.05Zm.667 5.52-.666-5.519-.397.048.666 5.52.397-.048Zm7.243 1.35L26.59 6.686l-.08.392 7.4 1.521.081-.391Zm.389.262a.607.607 0 0 0-.391-.262l-.076.393c.054.01.102.042.133.09l.334-.22Zm.087.46a.603.603 0 0 0-.088-.46l-.332.222c.03.044.04.1.03.155l.39.083ZM24.253 31.856l-9.78-6.78-.227.329 9.78 6.78.227-.33Zm2.66-4.109-2.937 4.158.326.23 2.938-4.157-.327-.23Zm-12.594-2.31 12.717 2.622.08-.392L14.4 25.045l-.08.391Zm13.02-5.106-8.225.976.047.397 8.225-.975-.047-.398Zm-.602-3.314.427 3.537.397-.048-.426-3.536-.398.047ZM18.98 8.722l7.808 8.408.294-.272-7.809-8.408-.293.272Zm-4.618 7.573 4.933-7.6-.336-.218-4.932 7.6.335.218Zm4.92 5.074-4.941-5.32-.293.273 4.942 5.32.293-.273Zm-1.182.057L4.563 23.03l.047.397 13.537-1.604-.047-.397Zm-7.484-7.585 7.361 7.92.293-.273-7.36-7.919-.294.272Zm-5.861 9.496 6.176-9.523-.336-.218L4.42 23.12l.336.217Zm21.44-10.807.304 2.52.056.46c.005.044.009.074.01.094l.003.02v.005-.008c0-.005.049-.146.177-.213l.046.398a.394.394 0 0 0 .176-.218v-.006l-.002-.005c0-.005 0-.011-.002-.021l-.011-.094a1917.934 1917.934 0 0 1-.36-2.98l-.396.048ZM24.913 1.888l1.282 10.642.398-.048L25.31 1.84l-.397.048ZM1.898 4.817l23.237-2.755-.047-.397L1.851 4.42l.047.398Zm2.34 17.719L2.073 4.594l-.397.048L3.84 22.584l.397-.048Zm5.953-9.825-6.319 9.74.336.218 6.319-9.74-.336-.218Zm.464-.277a.614.614 0 0 0-.463.276l.334.22a.214.214 0 0 1 .161-.098l-.032-.398Zm.5.192a.618.618 0 0 0-.5-.192l.032.398a.218.218 0 0 1 .178.068l.29-.274Zm2.607 2.804-2.605-2.803-.293.272 2.605 2.803.293-.272Zm4.792-7.84-5.106 7.867.336.218 5.106-7.867-.336-.218Zm.463-.277a.61.61 0 0 0-.463.277l.336.217a.21.21 0 0 1 .16-.095l-.033-.4Zm.501.192a.613.613 0 0 0-.503-.192l.037.398a.213.213 0 0 1 .175.068l.291-.274Zm7.395 7.962-7.394-7.961-.293.272 7.394 7.961.293-.272Zm.044.044-.018-.153a.061.061 0 0 0-.002-.009v-.004l-.001-.006-.004-.014a.381.381 0 0 0-.085-.114c-.17-.02-.302.124-.306.15a.307.307 0 0 0 0 .03v.016l.005.033.022.187.397-.048-.022-.186-.004-.032v.015a.37.37 0 0 1 0 .023c-.004.026-.136.17-.306.15a.381.381 0 0 1-.085-.114.257.257 0 0 1-.005-.02v-.004l-.001-.003.018.151.397-.048Zm0-.009-.395.066.394-.066Zm.01.08-.01-.071-.397.048.01.072.396-.048ZM29.55 27.33 9.766 23.25l-.08.392 19.783 4.08.08-.392Zm-.04-.004v.4-.4Zm3.115-15.595-3.311 15.754.391.083 3.312-15.755-.392-.082Zm.557-2.652-.557 2.652.392.082.557-2.652-.392-.082Zm-6.569-1.144 6.725 1.381.08-.392-6.724-1.381-.081.392Zm1.82 12.88-1.581-13.1-.397.048 1.58 13.1.398-.048Zm-.54.68a.615.615 0 0 0 .54-.68l-.397.047a.215.215 0 0 1-.19.235l.047.397ZM9.75 23.644l18.144-2.15-.047-.398-18.144 2.15.047.398Zm22.091-2.22 1.304-6.197-.391-.083-1.304 6.198.391.082Zm3.007-4.925L31.48 21.27l.327.23 3.365-4.768-.326-.23Zm-2.013-1.149 2.062 1.43.228-.33-2.062-1.429-.227.329ZM18.61 10.749l-2.776 4.275.335.218 2.776-4.276-.335-.217Zm.847-.182a.613.613 0 0 0-.848.182l.336.217a.213.213 0 0 1 .295-.063l.217-.336Zm.183.843a.608.608 0 0 0-.184-.843l-.215.337a.208.208 0 0 1 .064.288l.335.218Zm-2.776 4.276 2.776-4.276-.336-.218-2.776 4.276.336.218Zm-.848.181c.278.18.662.105.848-.181l-.336-.218a.216.216 0 0 1-.294.063l-.218.336Zm-.182-.843a.608.608 0 0 0 .183.844l.216-.337a.208.208 0 0 1-.064-.289l-.335-.218Zm-7.116 3.94.833-1.285-.335-.218-.834 1.284.336.218Zm.064.288a.208.208 0 0 1-.064-.288l-.335-.219a.608.608 0 0 0 .183.844l.216-.337Zm.295-.063a.216.216 0 0 1-.295.063l-.217.336c.278.18.662.105.848-.181l-.336-.218Zm.834-1.284-.834 1.284.336.218.833-1.285-.335-.217Zm2.425-.209a1.546 1.546 0 0 0-2.426.209l.336.217c.4-.617 1.288-.7 1.797-.153l.293-.273Zm.918.988-.918-.987-.293.272.918.987.293-.272Zm.3.013a.214.214 0 0 1-.3-.013l-.293.272c.23.247.618.264.866.034l-.272-.293Zm.015-.294a.206.206 0 0 1-.013.293l.27.296a.606.606 0 0 0 .035-.863l-.292.274Zm-.918-.988.918.987.292-.272-.917-.987-.293.272Zm-3.1.264c.698-1.077 2.232-1.201 3.1-.264l.293-.272c-1.043-1.127-2.888-.98-3.728.318l.335.218Zm-.364-.07.393-.078-.393.078ZM5.476 8.891a1.948 1.948 0 0 0 1.938 1.707v-.4a1.548 1.548 0 0 1-1.54-1.355l-.398.048Zm.027.079.343-.206-.343.206Zm1.68-2.232A1.942 1.942 0 0 0 5.477 8.89l.397-.048a1.542 1.542 0 0 1 1.358-1.708l-.047-.397ZM9.356 8.43a1.951 1.951 0 0 0-2.17-1.694l.044.398a1.551 1.551 0 0 1 1.728 1.344l.398-.048Zm-1.708 2.154A1.942 1.942 0 0 0 9.355 8.43l-.398.048A1.542 1.542 0 0 1 7.6 10.187l.047.398Zm-.233.013c.078 0 .154-.005.23-.013l-.042-.398c-.065.007-.128.01-.188.01v.4Zm-.084-2.65c.388-.049.758.23.806.628l.397-.048a1.124 1.124 0 0 0-1.253-.976l.05.397Zm-.635.798a.721.721 0 0 1 .634-.797l-.047-.398a1.121 1.121 0 0 0-.985 1.243l.398-.048Zm.805.628a.718.718 0 0 1-.806-.628l-.397.048a1.118 1.118 0 0 0 1.254.976L7.5 9.374Zm.636-.798a.721.721 0 0 1-.634.797l.047.398a1.121 1.121 0 0 0 .984-1.243l-.397.048Zm-.83-2.619a.211.211 0 0 1-.214.235v.4a.611.611 0 0 0 .61-.682l-.397.047ZM7.2 5.086l.105.872.397-.048-.105-.872-.397.048Zm-.242-.184a.215.215 0 0 1 .242.184l.397-.048a.615.615 0 0 0-.678-.534l.04.398Zm-.182.233a.212.212 0 0 1 .186-.233l-.047-.397a.612.612 0 0 0-.537.678l.398-.048Zm.105.872-.105-.872-.398.048.106.872.397-.048Zm.211.185a.21.21 0 0 1-.21-.184l-.398.046a.61.61 0 0 0 .608.538v-.4Zm-.2.2h.4-.4ZM4.898 7.473c.267.208.649.161.859-.102l-.313-.25a.215.215 0 0 1-.301.036l-.245.316ZM4.2 6.931l.696.542.246-.316-.696-.542-.246.316Zm-.103-.858a.606.606 0 0 0 .104.858l.244-.316a.206.206 0 0 1-.035-.292l-.313-.25Zm.86-.102a.618.618 0 0 0-.86.102l.313.25a.218.218 0 0 1 .301-.036l.245-.316Zm.696.543-.696-.543-.246.316.696.542.246-.315Zm.103.857a.606.606 0 0 0-.103-.858l-.245.317c.091.07.107.202.035.292l.313.249Zm-.833 1.584a.21.21 0 0 1-.187.233l.047.397a.61.61 0 0 0 .537-.678l-.397.048Zm-.241-.184a.219.219 0 0 1 .24.184l.398-.048a.619.619 0 0 0-.678-.534l.04.398Zm-.877.105.88-.105-.047-.397-.88.104.047.398Zm-.187.232a.21.21 0 0 1 .187-.232l-.047-.398a.61.61 0 0 0-.537.679l.397-.049Zm.242.184c-.135.013-.229-.077-.242-.184l-.397.048a.612.612 0 0 0 .678.534l-.039-.398Zm.876-.104-.88.104.047.398.88-.105-.047-.397Zm.514 1.215-.548.69.314.248.547-.69-.313-.248Zm.86-.102a.615.615 0 0 0-.86.101l.313.25a.215.215 0 0 1 .3-.036l.247-.315Zm.102.857a.607.607 0 0 0-.102-.857l-.247.315a.207.207 0 0 1 .036.293l.313.25Zm-.547.69.548-.69-.314-.249-.547.69.313.249Zm-.86.102c.268.208.65.161.86-.102l-.313-.25a.215.215 0 0 1-.3.036l-.246.316Zm-.102-.857a.606.606 0 0 0 .102.857l.247-.315a.207.207 0 0 1-.036-.293l-.313-.25Zm2.82.27a.21.21 0 0 1 .186-.232l-.047-.398a.61.61 0 0 0-.536.679l.397-.049Zm.105.873-.105-.872-.397.048.105.872.397-.048Zm.212.185a.212.212 0 0 1-.212-.186l-.397.049a.612.612 0 0 0 .609.537v-.4Zm.212-.235a.212.212 0 0 1-.212.235v.4c.37 0 .652-.32.61-.682l-.398.047Zm-.105-.871.106.872.397-.048-.106-.872-.397.048Zm-.24-.184a.217.217 0 0 1 .24.183l.397-.047a.617.617 0 0 0-.68-.534l.043.398Zm2.224-1.283a.615.615 0 0 0-.86.102l.314.25a.215.215 0 0 1 .3-.036l.246-.316Zm.697.543-.697-.542-.245.315.696.542.246-.315Zm.103.857a.606.606 0 0 0-.103-.857l-.246.315a.206.206 0 0 1 .036.293l.313.25Zm-.86.102c.268.208.65.161.86-.102l-.313-.25a.215.215 0 0 1-.302.036l-.245.316Zm-.696-.542.696.542.246-.316-.697-.542-.245.316Zm-.103-.858a.607.607 0 0 0 .102.857l.247-.315a.207.207 0 0 1-.036-.292l-.313-.25Zm1.544-1.455c-.215.038-.402.07-.542.049-.064-.01-.1-.029-.12-.048-.019-.017-.043-.051-.053-.13l-.397.048c.019.152.076.28.177.374.098.092.22.134.334.151.218.033.477-.016.671-.05l-.07-.394Zm.433-.051c-.13-.004-.293.026-.433.05l.07.395c.157-.028.271-.048.35-.045l.013-.4Zm.157-.232a.212.212 0 0 1-.187.233l.047.398a.612.612 0 0 0 .537-.679l-.397.048Zm-.243-.183c.129-.012.23.074.243.183l.397-.048a.616.616 0 0 0-.676-.533l.036.398Zm-.875.104.88-.104-.047-.398-.88.105.047.397Zm-.186.234a.213.213 0 0 1 .186-.234l-.047-.397a.613.613 0 0 0-.537.677l.398-.046Zm-.2.223v-.4.4ZM9.58 6.92l.548-.69-.314-.249-.547.69.313.249Zm-.859.102c.266.206.649.16.859-.101l-.312-.25a.218.218 0 0 1-.302.035l-.245.316Zm-.103-.857a.606.606 0 0 0 .103.857l.245-.316a.206.206 0 0 1-.035-.292l-.313-.25Zm.547-.69-.547.69.313.249.547-.69-.313-.249Zm.86-.102a.615.615 0 0 0-.86.102l.313.25a.215.215 0 0 1 .3-.036l.246-.316Zm.102.857a.606.606 0 0 0-.103-.857l-.245.316c.092.07.107.202.035.292l.313.25Z",
  fill: "currentColor"
})));

/* harmony default export */ var icon_gallery = (SvgIconGallery);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/elements/SlickSlider/index.js + 2 modules
var SlickSlider = __webpack_require__(12817);
// EXTERNAL MODULE: ./components/pages/single-property/Gallery/components/Modal/styles.module.scss
var Modal_styles_module = __webpack_require__(14192);
var Modal_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modal_styles_module);
;// CONCATENATED MODULE: ./public/icons/icon-slider.svg
var icon_slider_path;

function icon_slider_extends() { icon_slider_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_slider_extends.apply(this, arguments); }



const SvgIconSlider = props => /*#__PURE__*/react.createElement("svg", icon_slider_extends({
  width: 81,
  height: 8,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_slider_path || (icon_slider_path = /*#__PURE__*/react.createElement("path", {
  d: "M.646 4.354a.5.5 0 0 1 0-.708L3.828.464a.5.5 0 0 1 .708.708L1.707 4l2.829 2.828a.5.5 0 1 1-.708.708L.646 4.354ZM81 4.5H1v-1h80v1Z",
  fill: "currentColor"
})));

/* harmony default export */ var icon_slider = (SvgIconSlider);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/single-property/Gallery/components/Modal/index.js








var Modal = function(param) {
    var property = param.property, translations = param.translations;
    var router = (0,next_router.useRouter)();
    var videos = !(0,isEmpty/* default */.Z)(property.video) && property.video.map(function(item) {
        return (0,getS3Url/* getS3Url */.v)(item);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Modal_styles_module_default()).city,
                children: property.city || property.county
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: property.propertyTitle || property.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickSlider/* default */.Z, {
                className: (Modal_styles_module_default()).slider,
                slidesToShow: 1,
                synced: true,
                videos: videos,
                cloudflare: property.cloudflare_additional_video,
                infinite: false,
                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Modal_styles_module_default()).slider__arrow,
                    children: [
                        translations === null || translations === void 0 ? void 0 : translations.next[router.locale],
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_slider, {})
                    ]
                }),
                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,withModifiers/* withModifiers */.i)("slider__arrow", [
                        "left"
                    ], (Modal_styles_module_default())),
                    children: [
                        translations === null || translations === void 0 ? void 0 : translations.previous[router.locale],
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_slider, {})
                    ]
                }),
                children: property.cloudflare_gallery && !(0,isEmpty/* default */.Z)(property.cloudflare_gallery) ? property === null || property === void 0 ? void 0 : property.cloudflare_gallery.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Modal_styles_module_default()).slider__gallery,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                index: index,
                                sizes: "(min-width: 1250px) 1250px, (max-width: 1250px) 50vw, 1250px",
                                src: (0,getS3Url/* getS3Url */.v)(item)
                            })
                        })
                    }, index);
                }) : (property === null || property === void 0 ? void 0 : property.pictures) && (property === null || property === void 0 ? void 0 : property.pictures.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Modal_styles_module_default()).slider__gallery,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    index: index,
                                    sizes: "(min-width: 1250px) 1250px, (max-width: 1250px) 50vw, 1250px",
                                    src: item.original
                                }),
                                "hello"
                            ]
                        })
                    }, index);
                }))
            })
        ]
    });
};
/* harmony default export */ var components_Modal = (Modal);

// EXTERNAL MODULE: ./components/helpers/getRandom.js
var getRandom = __webpack_require__(91647);
// EXTERNAL MODULE: ./components/custom/GalleryGrid/index.js
var GalleryGrid = __webpack_require__(51012);
// EXTERNAL MODULE: ./providers/authProvider.js
var authProvider = __webpack_require__(89149);
// EXTERNAL MODULE: ./public/icons/icon-external.svg
var icon_external = __webpack_require__(97910);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./components/pages/single-property/Gallery/index.js
















var Gallery = function(param) {
    var property = param.property, _background = param.background, background = _background === void 0 ? "white" : _background, translations = param.translations;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var ref5 = (0,modalProvider/* useModalContext */.vR)(), setContent = ref5.setContent, handleShowModal = ref5.handleShowModal, setVariant = ref5.setVariant;
    var isAuthorized = (0,authProvider/* useAuthContext */.Eu)().isAuthorized;
    var ref6 = (0,react.useState)([]), images = ref6[0], setImages = ref6[1];
    if ((property === null || property === void 0 ? void 0 : (ref = property.pictures) === null || ref === void 0 ? void 0 : ref.length) < 4) {
        return;
    }
    (0,react.useEffect)(function() {
        if (property.cloudflare_gallery && !(0,isEmpty/* default */.Z)(property.cloudflare_gallery)) {
            var gallery = property.cloudflare_gallery.length < 5 ? property.cloudflare_gallery : (0,getRandom/* getRandom */.s)(property.cloudflare_gallery, 5);
            var images = gallery.map(function(picture, index) {
                return (0,getS3Url/* getS3Url */.v)(picture, index === 1 ? isMobile ? "640" : "960" : "640");
            });
            setImages(images);
        } else {
            setImages((0,getRandom/* getRandom */.s)(property === null || property === void 0 ? void 0 : property.pictures, 5));
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        variant: [
            background,
            "p0"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryGrid/* default */.Z, {
            images: images,
            button: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).buttons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        arrow: false,
                        onClick: function() {
                            setContent(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                                translations: translations,
                                property: property
                            }));
                            setVariant([
                                "prevent-outside-close"
                            ]);
                            handleShowModal();
                        },
                        variant: [
                            "primary-blue",
                            "xs"
                        ],
                        prepend: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_gallery, {
                            width: 35,
                            height: 32
                        }),
                        children: translations.browse[router.locale]
                    }),
                    property.ontraport_script && property.ontraport_script.startsWith("https") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        href: property.ontraport_script,
                        appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {}),
                        variant: [
                            "color-primary"
                        ],
                        target: "_blank",
                        children: "3D Tour"
                    }),
                    isAuthorized && (property === null || property === void 0 ? void 0 : (ref1 = property.attachment) === null || ref1 === void 0 ? void 0 : ref1.unbranded_video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        href: property === null || property === void 0 ? void 0 : (ref2 = property.attachment) === null || ref2 === void 0 ? void 0 : ref2.unbranded_video,
                        appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {}),
                        variant: [
                            "color-primary"
                        ],
                        target: "_blank",
                        children: "Unbranded Video"
                    }),
                    isAuthorized && (property === null || property === void 0 ? void 0 : (ref3 = property.attachment) === null || ref3 === void 0 ? void 0 : ref3.gallery) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        href: property === null || property === void 0 ? void 0 : (ref4 = property.attachment) === null || ref4 === void 0 ? void 0 : ref4.gallery,
                        appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {}),
                        variant: [
                            "color-primary"
                        ],
                        target: "_blank",
                        children: translations.download[router.locale]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var single_property_Gallery = (Gallery);


/***/ }),

/***/ 38122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70539);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40050);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41197);
/* harmony import */ var _custom_Highlight__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(958);
/* harmony import */ var _custom_Staff__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33528);
/* harmony import */ var _public_icons_icon_previous_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25056);
/* harmony import */ var _public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38875);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30410);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34495);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40670);

















var Introduction = function(param) {
    var location = param.location, title = param.title, description = param.description, contact = param.contact, _button = param.button, button = _button === void 0 ? true : _button, translations = param.translations;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var isRealEstate = router.pathname.includes("real-estate");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__/* .useResponsive */ .F)(), isDesktop = ref1.isDesktop, isSmallMobile = ref1.isSmallMobile;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), loaded = ref2[0], setLoaded = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "white",
                "p-xl"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: [
                        isSmallMobile ? "-align-center" : "-distribute-between"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : 6,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                            arrow: false,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro__button),
                                            prepend: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_previous_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                width: 23
                                            }),
                                            variant: [
                                                "label",
                                                "blue"
                                            ],
                                            onClick: function() {
                                                return router.back();
                                            },
                                            children: translations === null || translations === void 0 ? void 0 : translations.back[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro__divider),
                                            children: "/"
                                        }),
                                        " ",
                                        location
                                    ]
                                }),
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro__title),
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro__description", [
                                                show && "is-visible"
                                            ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default())),
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro__more),
                                            arrow: false,
                                            appendIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro__icon", [
                                                    show && "up"
                                                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default()))
                                            }),
                                            variant: [
                                                "label",
                                                "blue"
                                            ],
                                            onClick: function() {
                                                return setShow(!show);
                                            },
                                            children: show ? translations === null || translations === void 0 ? void 0 : translations.readLess[router.locale] : translations === null || translations === void 0 ? void 0 : translations.readMore[router.locale]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 8 : 5,
                            children: contact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().intro__column),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Staff__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                    variant: [
                                        !isDesktop && "align-middle",
                                        isDesktop && "columns",
                                        "remove-job",
                                        isRealEstate && "color-accent"
                                    ]
                                }, contact), {
                                    button: button && {
                                        label: isRealEstate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    variant: [
                                                        "accent",
                                                        "arrow-accent",
                                                        "offset-left"
                                                    ],
                                                    children: translations === null || translations === void 0 ? void 0 : translations.buying[router.locale]
                                                }),
                                                translations === null || translations === void 0 ? void 0 : translations.options[router.locale]
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                translations === null || translations === void 0 ? void 0 : translations.askAbout[router.locale],
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    children: translations === null || translations === void 0 ? void 0 : translations.renting[router.locale]
                                                })
                                            ]
                                        }),
                                        variant: "arrow-accent"
                                    }
                                }))
                            })
                        })
                    ]
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Introduction);


/***/ }),

/***/ 15005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ single_property_Map; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(28499);
// EXTERNAL MODULE: ./components/pages/single-property/Map/styles.module.scss
var styles_module = __webpack_require__(98925);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-marker.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMarker = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 14,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M7.014 20.153c3.171 0 6.433-2.287 6.433-6.153 0-2.16-1.117-3.656-3.495-4.802-1.085-.528-2.287-.935-3.32-1.405C4.546 6.885 3.96 5.828 3.96 4.45c0-1.727 1.117-2.842 2.79-2.842 1.911 0 3.643 1.574 5.258 4.801l.588-.09-.498-5.74h-.498l-1.144.992c-.969-.56-1.97-.966-3.436-.966-2.965 0-5.994 2.112-5.994 5.598 0 2.14 1.086 3.75 3.145 4.775.911.439 1.997.819 2.939 1.204 2.759 1.141 3.437 1.992 3.437 3.75 0 1.85-1.234 3.223-3.352 3.223s-4.2-1.347-6.052-5.568l-.615.059.35 6.507h.53l1.143-1.025a9.91 9.91 0 0 0 4.464 1.025Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_marker = (SvgIconMarker);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/pages/single-property/Map/index.js









// to be moved to elements Map
var Map = function(param) {
    var lat = param.lat, lng = param.lng, points = param.points, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    var ref, ref1;
    var ref2 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref2.isMobile, isTablet = ref2.isTablet;
    var ref3 = (0,react.useState)(false), maps = ref3[0], setMaps = ref3[1];
    var hasSection = variant.includes("section");
    var ref4 = (0,react.useState)(false), loaded = ref4[0], setLoaded = ref4[1];
    var Marker = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).map__marker,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_marker, {})
        });
    };
    (0,react.useEffect)(function() {
        var onPageLoad = function() {
            setLoaded(true);
        };
        // Check if the page has already loaded
        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad);
            // Remove the event listener when component unmounts
            return function() {
                return window.removeEventListener("load", onPageLoad);
            };
        }
    }, []);
    if (!loaded && (!lng || !lat || points)) {
        return;
    }
    var defaultProps = {
        center: {
            lat: Number(lat) || Number((ref = points[0]) === null || ref === void 0 ? void 0 : ref.lat),
            lng: points ? Number((ref1 = points[0]) === null || ref1 === void 0 ? void 0 : ref1.lng) : Number(lng)
        },
        zoom: isMobile ? 12 : 13
    };
    if (hasSection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            className: (styles_module_default()).section,
            variant: [
                "p0"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                variant: [
                    isTablet && "-p0"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).map,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
                        bootstrapURLKeys: {
                            // eslint-disable-next-line no-undef
                            key: "AIzaSyCYNyhjZek7H1qMVK4kJB3M6jTokrr7FDs"
                        },
                        onGoogleApiLoaded: function(param) {
                            var maps = param.maps;
                            return setMaps(maps);
                        },
                        options: {
                            mapTypeControl: true,
                            mapTypeControlOptions: maps && {
                                mapTypeIds: [
                                    maps.MapTypeId.ROADMAP,
                                    maps.MapTypeId.SATELLITE
                                ]
                            }
                        },
                        yesIWantToUseGoogleMapApiInternals: true,
                        center: defaultProps.center,
                        zoom: defaultProps.zoom,
                        children: points ? points.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                lng: item.lng,
                                lat: item.lat
                            }, index);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                            lng: lng,
                            lat: lat
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,withModifiers/* withModifiers */.i)("map", [
            "full-width"
        ], (styles_module_default())),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
            bootstrapURLKeys: {
                // eslint-disable-next-line no-undef
                key: "AIzaSyCYNyhjZek7H1qMVK4kJB3M6jTokrr7FDs"
            },
            yesIWantToUseGoogleMapApiInternals: true,
            center: defaultProps.center,
            zoom: defaultProps.zoom,
            onGoogleApiLoaded: function(param) {
                var maps = param.maps;
                return setMaps(maps);
            },
            options: {
                mapTypeControl: true,
                mapTypeControlOptions: maps && {
                    mapTypeIds: [
                        maps.MapTypeId.ROADMAP,
                        maps.MapTypeId.SATELLITE
                    ]
                }
            },
            children: points ? points.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                    lng: item.lng,
                    lat: item.lat
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                lng: lng,
                lat: lat
            })
        })
    });
};
/* harmony default export */ var single_property_Map = (Map);


/***/ }),

/***/ 51219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40050);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70539);
/* harmony import */ var _elements_LineSeparator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96143);
/* harmony import */ var _components_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87086);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63405);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34495);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20027);














var Welcome = function(_param) {
    var property = _param.property, video = _param.video, background = _param.background, title = _param.title, description = _param.description, configuration = _param.configuration, translations = _param.translations, cardTranslations = _param.cardTranslations, cloudflare = _param.cloudflare, _sold = _param.sold, sold = _sold === void 0 ? false : _sold, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "property",
        "video",
        "background",
        "title",
        "description",
        "configuration",
        "translations",
        "cardTranslations",
        "cloudflare",
        "sold"
    ]);
    var ref, ref1;
    var ref2 = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__/* .useResponsive */ .F)(), isDesktop = ref2.isDesktop, isTablet = ref2.isTablet, isMobile = ref2.isMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    // Check if the URL can be modified for different sizes (Cloudflare)
    var isCloudflare = typeof background === "string" && background.includes("imagedelivery.net");
    // Create URLs for different sizes if possible, otherwise use the original
    var getImageUrl = function(size) {
        if (!background || typeof background !== "string") return null;
        if (!isCloudflare) return background;
        return background.replace(/\/([^/]+)$/, "/".concat(size));
    };
    // Create image URLs for different sizes
    var imageUrls = {
        small: getImageUrl("360"),
        medium: getImageUrl("640"),
        large: getImageUrl("960"),
        xlarge: getImageUrl("1980")
    };
    var imageProps = {
        src: imageUrls.xlarge,
        alt: translations.welcome.content.imageAlt[router.locale],
        sizes: "(max-width: 360px) 360px, (max-width: 640px) 640px, (max-width: 960px) 960px, 1980px",
        srcSet: imageUrls.xlarge ? "".concat(imageUrls.medium, " 360w,\n             ").concat(imageUrls.medium, " 640w,\n             ").concat(imageUrls.large, " 960w,\n             ").concat(imageUrls.xlarge, " 1980w") : null
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            video: video,
            grayscale: sold,
            // bg={imageUrls.xlarge}
            cloudflare: cloudflare,
            variant: [
                "p0",
                "image-full"
            ],
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_12__/* .withModifiers */ .i)("welcome__image", [
                        sold && "grayscale"
                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default())),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        priority: true,
                        fetchpriority: "high",
                        width: 1980,
                        layout: "fill",
                        objectPosition: "center",
                        objectFit: "cover",
                        height: 1080,
                        srcSet: imageProps.srcSet,
                        sizes: imageProps.sizes,
                        src: imageUrls.xlarge,
                        alt: imageProps.alt
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__content),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: [
                                "-align-bottom",
                                "-distribute-between"
                            ],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__left),
                                    spans: isTablet ? 12 : isDesktop ? 7 : 6,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__tag),
                                            children: [
                                                property === null || property === void 0 ? void 0 : property.city,
                                                " ",
                                                (property === null || property === void 0 ? void 0 : (ref = property.address) === null || ref === void 0 ? void 0 : ref.country) && (property === null || property === void 0 ? void 0 : property.region_side) || (property === null || property === void 0 ? void 0 : (ref1 = property.locations) === null || ref1 === void 0 ? void 0 : ref1.title)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__title),
                                            children: title
                                        }),
                                        property.promo_code_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: property.promo_code_description
                                            },
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__promo)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Columns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__details),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        width: isMobile && 31
                                                    }),
                                                    (description || configuration) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__description),
                                                        children: [
                                                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: description
                                                                },
                                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().welcome__paragraph)
                                                            }),
                                                            configuration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: configuration
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    spans: isTablet ? 12 : 5,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                        cardTranslations: cardTranslations,
                                        property: property,
                                        expandable: true,
                                        translations: translations.welcome.card
                                    }, props))
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Welcome);


/***/ }),

/***/ 87086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/styles.module.scss
var styles_module = __webpack_require__(52400);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/custom/HouseDetails/index.js + 2 modules
var HouseDetails = __webpack_require__(71372);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./components/elements/DropdownField/index.js
var DropdownField = __webpack_require__(16971);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./public/icons/icon-calendar.svg
var icon_calendar = __webpack_require__(48976);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(50576);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Arrive/index.js










var Calendar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(47), __webpack_require__.e(5474)]).then(__webpack_require__.bind(__webpack_require__, 34705));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34705)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading calendar..."
        });
    }
});
var Arrive = function(_param) {
    var setFieldValue = _param.form.setFieldValue, width = _param.width, property = _param.property, blockedDates = _param.blockedDates, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "form",
        "width",
        "property",
        "blockedDates",
        "label"
    ]);
    var ref;
    var ref1 = (0,SearchContext/* useSearchContext */.AB)(), search = ref1.search, initialValues = ref1.initialValues, setSearch = ref1.setSearch, offsetable = ref1.offsetable;
    var ref2 = (0,react.useState)(false), close = ref2[0], setClose = ref2[1];
    var ref3 = (0,react.useState)(offsetable === 0 && (search === null || search === void 0 ? void 0 : search.startDate) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.startDate)), startDate = ref3[0], setStartDate = ref3[1];
    var startDateString = search.startDate ? search.startDate.format("MMM D") : false;
    (0,react.useEffect)(function() {
        if (search.endDate && search.startDate && search.endDate.isBefore(search.startDate, "day")) {
            setStartDate(initialValues.startDate);
        }
    }, [
        search.endDate
    ]);
    (0,react.useEffect)(function() {
        setClose(true);
        setTimeout(function() {
            return setClose(false);
        }, 10);
        setFieldValue("endDate", startDate);
        setTimeout(function() {
            return setSearch && setSearch(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    startDate: startDate
                });
            });
        }, 10);
    }, [
        startDate
    ]);
    (0,react.useEffect)(function() {
        setClose(true);
        setTimeout(function() {
            return setClose(false);
        }, 10);
        setSearch && setSearch(function() {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
                startDate: startDate
            });
        });
    }, [
        startDate
    ]);
    var handleClear = function() {
        setSearch && setSearch(function() {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
                startDate: initialValues === null || initialValues === void 0 ? void 0 : initialValues.startDate
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: search.startDate,
        prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {
            width: 26,
            height: 26
        }),
        triggerClose: close,
        onClear: handleClear,
        disabled: !property.is_active,
        value: search.startDate ? startDateString : label,
        disableApply: (0,isEqual/* default */.Z)(search.startDate, startDate),
        disableClear: search.startDate === null
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: width,
                display: "flex",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {
                type: "startDate",
                blockedDates: blockedDates,
                isDayBlocked: search === null || search === void 0 ? void 0 : search.endDate,
                numberOfMonths: 1,
                startDate: startDate,
                setStartDate: setStartDate,
                minNights: (property === null || property === void 0 ? void 0 : (ref = property.terms) === null || ref === void 0 ? void 0 : ref.minNights) || 7,
                disabled: !property.is_active
            }, blockedDates && blockedDates.length ? blockedDates.map(function(d) {
                return d.format ? d.format("YYYY-MM-DD") : d;
            }) : "none")
        })
    }));
};
/* harmony default export */ var components_Arrive = (Arrive);

;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Departure/index.js











var Departure_Calendar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(47), __webpack_require__.e(5474)]).then(__webpack_require__.bind(__webpack_require__, 34705));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34705)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading calendar..."
        });
    }
});
var Departure = function(_param) {
    var setFieldValue = _param.form.setFieldValue, variant = _param.variant, width = _param.width, property = _param.property, blockedDates = _param.blockedDates, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "form",
        "variant",
        "width",
        "property",
        "blockedDates",
        "label"
    ]);
    var ref;
    var ref1 = (0,SearchContext/* useSearchContext */.AB)(), search = ref1.search, initialValues = ref1.initialValues, setSearch = ref1.setSearch, offsetable = ref1.offsetable;
    var ref2 = (0,react.useState)(false), close = ref2[0], setClose = ref2[1];
    var ref3 = (0,react.useState)(offsetable === 0 && (search === null || search === void 0 ? void 0 : search.endDate) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.endDate)), endDate = ref3[0], setEndDate = ref3[1];
    var endDateString = search.endDate && search.endDate.format("MMM D");
    (0,react.useEffect)(function() {
        if (search.endDate && search.startDate && search.endDate.isBefore(search.startDate, "day")) {
            setEndDate(initialValues.startDate);
        }
    }, [
        search.startDate
    ]);
    (0,react.useEffect)(function() {
        setClose(true);
        setTimeout(function() {
            return setClose(false);
        }, 10);
        setFieldValue("endDate", endDate);
        setTimeout(function() {
            return setSearch && setSearch(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    endDate: endDate
                });
            });
        }, 10);
    }, [
        endDate
    ]);
    var handleClear = function() {
        setSearch && setSearch(function() {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
                endDate: initialValues === null || initialValues === void 0 ? void 0 : initialValues.endDate
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: search.endDate,
        prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {
            width: 26,
            height: 26
        }),
        triggerClose: close,
        onClear: handleClear,
        disabled: !property.is_active,
        variant: (0,_to_consumable_array/* default */.Z)(variant).concat([
            "right"
        ]),
        disableApply: (0,isEqual/* default */.Z)(search.endDate, endDate),
        disableClear: search.endDate === null,
        value: search.endDate ? endDateString : label
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: width,
                display: "flex",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Departure_Calendar, {
                numberOfMonths: 1,
                type: "endDate",
                startDate: endDate,
                blockedDates: blockedDates,
                setStartDate: setEndDate,
                minNights: (property === null || property === void 0 ? void 0 : (ref = property.terms) === null || ref === void 0 ? void 0 : ref.minNights) || 7
            }, blockedDates && blockedDates.length ? blockedDates.map(function(d) {
                return d.format ? d.format("YYYY-MM-DD") : d;
            }) : "none")
        })
    }));
};
/* harmony default export */ var components_Departure = (Departure);

// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Bedrooms/styles.module.scss
var Bedrooms_styles_module = __webpack_require__(9337);
var Bedrooms_styles_module_default = /*#__PURE__*/__webpack_require__.n(Bedrooms_styles_module);
// EXTERNAL MODULE: ./public/icons/icon-bedroom.svg
var icon_bedroom = __webpack_require__(83316);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Bedrooms/index.js












var Bedrooms = function(_param) {
    var setFieldValue = _param.form.setFieldValue, variant = _param.variant, width = _param.width, property = _param.property, translations = _param.translations, props = (0,_object_without_properties/* default */.Z)(_param, [
        "form",
        "variant",
        "width",
        "property",
        "translations"
    ]);
    var ref;
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,SearchContext/* useSearchContext */.AB)(), bedroomOptions = ref2.bedroomOptions, setBedroomOptions = ref2.setBedroomOptions, guests = ref2.guests;
    var ref3 = (0,react.useState)(false), close = ref3[0], setClose = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setBedroomOptions("");
    }, []);
    (0,react.useEffect)(function() {
        setValue(bedroomOptions);
        setFieldValue("bedrooms", bedroomOptions);
    }, [
        bedroomOptions
    ]);
    (0,react.useEffect)(function() {
        if (bedroomOptions && Number(bedroomOptions === null || bedroomOptions === void 0 ? void 0 : bedroomOptions.split(" ")[0]) * 2 < guests) {
            setValue([]);
            setBedroomOptions("");
            setFieldValue("bedrooms", []);
        }
    }, [
        guests
    ]);
    (0,react.useEffect)(function() {
        setClose(true);
        setTimeout(function() {
            return setClose(false);
        }, 100);
    }, [
        bedroomOptions
    ]);
    var handleChange = function(e) {
        setBedroomOptions && setBedroomOptions(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bedroom/* default */.Z, {
            width: 40,
            height: 28
        }),
        isActive: value.length !== 0,
        variant: (0,_to_consumable_array/* default */.Z)(variant).concat([
            "right"
        ]),
        triggerClose: close,
        disabled: !property.is_active,
        value: value.length !== 0 ? "".concat(translations.beds[router.locale], " ").concat(value) : translations === null || translations === void 0 ? void 0 : translations.bedrooms[router.locale],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: width
            },
            className: (Bedrooms_styles_module_default()).radios,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: (property === null || property === void 0 ? void 0 : property.bedroom_option) && (property === null || property === void 0 ? void 0 : (ref = property.bedroom_option) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                        name: "bedrooms",
                        value: item === null || item === void 0 ? void 0 : item.room_title,
                        label: item === null || item === void 0 ? void 0 : item.room_title,
                        checked: !(Number((ref = item.room_title) === null || ref === void 0 ? void 0 : ref.split(" ")[0]) * 2 < guests) && (item === null || item === void 0 ? void 0 : item.room_title) === bedroomOptions,
                        disabled: Number((ref1 = item.room_title) === null || ref1 === void 0 ? void 0 : ref1.split(" ")[0]) * 2 < guests,
                        onChange: function(e) {
                            return handleChange(e);
                        }
                    }, index);
                }))
            })
        })
    }));
};
/* harmony default export */ var components_Bedrooms = (Bedrooms);

// EXTERNAL MODULE: ./components/custom/Bedrooms/index.js
var custom_Bedrooms = __webpack_require__(75455);
;// CONCATENATED MODULE: ./public/icons/icon-guest.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconGuest = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M15.968 6.75c0 3.5-1.96 6.5-5 6.5s-5-3-5-6.5 1-5.5 5-5.5 5 2 5 5.5Z",
  stroke: "currentColor",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "m13.968 12.25 7 4v2c0 1.66-1 3-2 3h-16c-1 0-2-1.34-2-3v-2l7-4",
  stroke: "currentColor",
  strokeMiterlimit: 10
})));

/* harmony default export */ var icon_guest = (SvgIconGuest);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Guests/styles.module.scss
var Guests_styles_module = __webpack_require__(3542);
var Guests_styles_module_default = /*#__PURE__*/__webpack_require__.n(Guests_styles_module);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/Guests/index.js










var Guests = function(_param) {
    var width = _param.width, property = _param.property, label = _param.label, defaultProps = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "property",
        "label"
    ]);
    var ref;
    var ref1 = (0,SearchContext/* useSearchContext */.AB)(), setGuests = ref1.setGuests, guests = ref1.guests;
    var ref2 = (0,react.useState)(false), close = ref2[0], setClose = ref2[1];
    var total = 0;
    (property === null || property === void 0 ? void 0 : property.bedroom_option) && (property === null || property === void 0 ? void 0 : (ref = property.bedroom_option) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        var ref;
        var roomNumber = (ref = item.room_title) === null || ref === void 0 ? void 0 : ref.split(" ");
        if (roomNumber && Number(roomNumber[0]) > total) {
            total = Number(roomNumber[0]);
        }
    }));
    (0,react.useEffect)(function() {
        setGuests(null);
    }, []);
    (0,react.useEffect)(function() {
        setClose(true);
        setTimeout(function() {
            return setClose(false);
        }, 10);
    }, [
        guests
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: guests,
        prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_guest, {
            width: 22,
            height: 22
        }),
        name: "guests",
        disabled: !property.is_active,
        triggerClose: close,
        value: guests ? "".concat(label, ": ").concat(guests) : label
    }, defaultProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: width
            },
            className: (Guests_styles_module_default()).radios,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_Bedrooms/* default */.Z, {
                items: total * 2,
                bedroom: true,
                name: "guests",
                value: guests,
                setValue: setGuests
            })
        })
    }));
};
/* harmony default export */ var components_Guests = (Guests);

// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./components/elements/Grid/index.js
var Grid = __webpack_require__(117);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/styles.module.scss
var Reservation_styles_module = __webpack_require__(42450);
var Reservation_styles_module_default = /*#__PURE__*/__webpack_require__.n(Reservation_styles_module);
// EXTERNAL MODULE: ./public/icons/icon-external.svg
var icon_external = __webpack_require__(97910);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/index.js + 7 modules
var ModalContent = __webpack_require__(92448);
// EXTERNAL MODULE: ./components/pages/common/Contact/components/ContactForm/index.js
var ContactForm = __webpack_require__(64150);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
// EXTERNAL MODULE: ./components/helpers/withComma.js
var withComma = __webpack_require__(29828);
// EXTERNAL MODULE: ./providers/authProvider.js
var authProvider = __webpack_require__(89149);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/index.js























var Reservation = function(param) {
    var expandable = param.expandable, show = param.show, property = param.property, setShow = param.setShow, blockedDates = param.blockedDates, minNights = param.minNights, setBonuses = param.setBonuses, bonuses = param.bonuses, translations = param.translations;
    var ref = (0,SearchContext/* useSearchContext */.AB)(), initialValues = ref.initialValues, search = ref.search, bedroomOptions = ref.bedroomOptions, guests = ref.guests;
    var loggedIn = (0,authProvider/* useAuthContext */.Eu)().loggedIn;
    var ref1 = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref2 = (0,ResponsiveContext/* useResponsive */.F)(), isDesktop = ref2.isDesktop, isTablet = ref2.isTablet;
    var ref3 = (0,modalProvider/* useModalContext */.vR)(), setContent = ref3.setContent, handleShowModal = ref3.handleShowModal, setVariant = ref3.setVariant;
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(0), startingPrice = ref5[0], setStartingPrice = ref5[1];
    var ref6 = (0,react.useState)(0), width = ref6[0], setWidth = ref6[1];
    var formInitialValues = {
        startDate: initialValues === null || initialValues === void 0 ? void 0 : initialValues.startDate,
        endDate: initialValues === null || initialValues === void 0 ? void 0 : initialValues.endDate,
        bedrooms: [],
        guests: guests
    };
    //TODO: cleanup and reorganize this whole component
    // set the panel open width on page load
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var ref;
            return setWidth(((ref = ref1.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().width) - 80);
        }, 1000);
    }, []);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var ref;
            return setWidth(((ref = ref1.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().width) - 80);
        }, 1000);
    }, [
        show,
        isDesktop,
        isTablet
    ]);
    var ref7 = (0,react.useState)(false), nights = ref7[0], setNights = ref7[1];
    var ref8 = (0,react.useState)(false), taxes = ref8[0], setTaxes = ref8[1];
    var ref9 = (0,react.useState)(false), total = ref9[0], setTotal = ref9[1];
    var ref10 = (0,react.useState)(false), totalWithoutStripe = ref10[0], setTotalWithoutStripe = ref10[1];
    var ref11 = (0,react.useState)(false), numberOfFreeNights = ref11[0], setNumberOfFreeNights = ref11[1];
    var ref12 = (0,react.useState)(false), freeNightsCost = ref12[0], setFreeNightsCost = ref12[1];
    var ref13 = (0,react.useState)(false), freeNightsOldPrice = ref13[0], setFreeNightsOldPrice = ref13[1];
    var ref14 = (0,react.useState)(0), price = ref14[0], setPrice = ref14[1];
    var disabled = (search === null || search === void 0 ? void 0 : search.startDate) === null || (search === null || search === void 0 ? void 0 : search.endDate) === null || guests === null || bedroomOptions === "" || !property.is_active;
    (0,react.useEffect)(function() {
        if (search.startDate && search.endDate && bedroomOptions && guests) {
            var ref;
            setLoading(true);
            var endDate = search === null || search === void 0 ? void 0 : (ref = search.endDate) === null || ref === void 0 ? void 0 : ref.clone().startOf("day");
            setNights(endDate.diff(search.startDate.clone().startOf("day"), "days"));
            axios/* default.post */.Z.post("reservation/price-calculation", {
                lang: router.locale,
                id: property === null || property === void 0 ? void 0 : property.resource_id,
                startDate: search.startDate.clone().startOf("day").format("YYYY-MM-DD"),
                endDate: search.endDate.clone().startOf("day").format("YYYY-MM-DD"),
                bedrooms: bedroomOptions
            }).then(function(res) {
                var result = res.data;
                setPrice(result.totalCostPerNights);
                setTaxes(result.tax10);
                setTotalWithoutStripe(result.totalWith10Taxes);
                setTotal(result.finalCost);
                setNumberOfFreeNights(result.freeNights);
                setFreeNightsCost(result.freeNightlyRate);
                setFreeNightsOldPrice(result.initial);
                setLoading(false);
            }).catch(function(err) {
                return console.error(err);
            });
        }
    }, [
        search,
        bedroomOptions,
        guests,
        router.locale
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        axios/* default.get */.Z.get("listings/starting-price", {
            params: {
                lang: router.locale,
                startDate: (ref = search.startDate) === null || ref === void 0 ? void 0 : ref.clone().startOf("day").format("YYYY-MM-DD"),
                endDate: (ref1 = search.endDate) === null || ref1 === void 0 ? void 0 : ref1.clone().startOf("day").format("YYYY-MM-DD"),
                bedrooms: bedroomOptions,
                listingId: property === null || property === void 0 ? void 0 : property.resource_id
            }
        }).then(function(res) {
            var carBonusExists = res.data.bonuses && res.data.bonuses.includes("free_car");
            var nightBonusExists = res.data.bonuses && res.data.bonuses.includes("free_night");
            var giftBonusExists = res.data.bonuses && res.data.bonuses.includes("free_gift");
            setBonuses(function(prevBonuses) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevBonuses), {
                    car: carBonusExists,
                    gift: giftBonusExists,
                    night: nightBonusExists
                });
            });
            setStartingPrice(res.data.starting_at);
        }).catch(function(err) {
            return console.error(err);
        });
    }, [
        search.startDate,
        search.endDate,
        bedroomOptions,
        property,
        guests,
        setBonuses,
        router.locale
    ]);
    // set the minimum price out of all the bedroom options
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            enableReinitialize: true,
            initialValues: formInitialValues,
            children: function() {
                var ref;
                var defaultProps = {
                    variant: [
                        "full-width",
                        "footer-close"
                    ],
                    footer: false,
                    width: width,
                    property: property,
                    required: true
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    className: (Reservation_styles_module_default()).formik,
                    ref: ref1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,withModifiers/* withModifiers */.i)("form", [
                                isDesktop && expandable && show && "is-hidden"
                            ], (Reservation_styles_module_default())),
                            children: [
                                !blockedDates && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Reservation_styles_module_default()).form__nights,
                                    children: translations.bookingNoLoad[router.locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    variant: [
                                        "grid-2",
                                        isDesktop && "column-2xl",
                                        "spacing-xs"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread/* default */.Z)({
                                            blockedDates: blockedDates,
                                            component: components_Arrive,
                                            label: translations === null || translations === void 0 ? void 0 : translations.arrive[router.locale]
                                        }, defaultProps)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread/* default */.Z)({
                                            blockedDates: blockedDates,
                                            label: translations === null || translations === void 0 ? void 0 : translations.depart[router.locale],
                                            component: components_Departure
                                        }, defaultProps)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread/* default */.Z)({
                                            component: components_Guests,
                                            label: translations === null || translations === void 0 ? void 0 : translations.guests[router.locale]
                                        }, defaultProps)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread/* default */.Z)({
                                            component: components_Bedrooms,
                                            translations: translations
                                        }, defaultProps))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Reservation_styles_module_default()).form__pricing,
                                    children: [
                                        (search === null || search === void 0 ? void 0 : search.startDate) && (search === null || search === void 0 ? void 0 : search.endDate) && guests && minNights <= nights && bedroomOptions !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Reservation_styles_module_default()).form__row,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                "$",
                                                                (0,withComma/* withComma */.u)(price)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                "$",
                                                                (0,withComma/* withComma */.u)(price)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Reservation_styles_module_default()).form__row,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: translations.taxesFees[router.locale]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                "$",
                                                                (0,withComma/* withComma */.u)(parseFloat(taxes).toFixed(2))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Reservation_styles_module_default()).form__row,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: translations.total[router.locale]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                "$",
                                                                (0,withComma/* withComma */.u)(totalWithoutStripe)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                translations === null || translations === void 0 ? void 0 : translations.startingAt[router.locale],
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (Reservation_styles_module_default()).form__number,
                                                    children: [
                                                        "$",
                                                        (0,withComma/* withComma */.u)(startingPrice)
                                                    ]
                                                }),
                                                " ",
                                                !(search.startDate && search.endDate) && (translations === null || translations === void 0 ? void 0 : translations.perNight[router.locale])
                                            ]
                                        }),
                                        minNights && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Reservation_styles_module_default()).form__nights,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: minNights
                                                }),
                                                " ",
                                                translations === null || translations === void 0 ? void 0 : translations.minNights[router.locale]
                                            ]
                                        })
                                    ]
                                }),
                                isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                    className: (Reservation_styles_module_default()).form__button,
                                    disabled: disabled,
                                    type: "button",
                                    onClick: function() {
                                        if (disabled) {
                                            setShow(!show);
                                        } else if (minNights > nights || !blockedDates) {
                                            setContent(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: (Reservation_styles_module_default()).form__title,
                                                        children: translations.contactDetails[router.locale]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Reservation_styles_module_default()).form__subtitle,
                                                        children: blockedDates ? translations.lessDays[router.locale] : translations.issueLoading[router.locale]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                                                        total: total,
                                                        translations: translations,
                                                        startDate: search.startDate.format("YYYY-MM-DD"),
                                                        endDate: search.endDate.format("YYYY-MM-DD"),
                                                        propertyName: property === null || property === void 0 ? void 0 : property.propertyTitle,
                                                        bedrooms: bedroomOptions,
                                                        guests: guests,
                                                        route: blockedDates ? "email/send" : "email/payment"
                                                    })
                                                ]
                                            }));
                                            setVariant([
                                                "contained"
                                            ]);
                                            handleShowModal();
                                        } else {
                                            setContent(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* default */.Z, {
                                                numberOfFreeNights: numberOfFreeNights,
                                                freeNightsCost: freeNightsCost,
                                                freeNightsOldPrice: freeNightsOldPrice,
                                                totalWithoutStripe: totalWithoutStripe,
                                                total: total,
                                                taxesAndFess: taxes,
                                                totalCostPerNights: price,
                                                startDate: search.startDate.format("YYYY-MM-DD"),
                                                endDate: search.endDate.format("YYYY-MM-DD"),
                                                propertyId: property === null || property === void 0 ? void 0 : property.resource_id,
                                                bedrooms: bedroomOptions,
                                                property: property,
                                                guests: guests,
                                                translations: translations,
                                                bonuses: bonuses
                                            }));
                                            setVariant([
                                                "contained"
                                            ]);
                                            handleShowModal();
                                        }
                                    },
                                    variant: [
                                        expandable && !show && "full-width",
                                        "gold"
                                    ],
                                    arrow: false,
                                    children: translations === null || translations === void 0 ? void 0 : translations.book[router.locale]
                                })
                            ]
                        }),
                        !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            className: (Reservation_styles_module_default()).form__button,
                            disabled: isDesktop ? !show && disabled : disabled || loading,
                            type: "button",
                            onClick: function() {
                                if (disabled) {
                                    setShow(!show);
                                } else if (minNights > nights || !blockedDates) {
                                    setContent(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: (Reservation_styles_module_default()).form__title,
                                                children: translations.contactDetails[router.locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Reservation_styles_module_default()).form__subtitle,
                                                children: blockedDates ? translations.lessDays[router.locale] : translations.issueLoading[router.locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                                                translations: translations,
                                                variant: [
                                                    "dark"
                                                ],
                                                total: total,
                                                startDate: search.startDate.format("YYYY-MM-DD"),
                                                endDate: search.endDate.format("YYYY-MM-DD"),
                                                propertyName: property === null || property === void 0 ? void 0 : property.propertyTitle,
                                                bedrooms: bedroomOptions,
                                                guests: guests,
                                                route: blockedDates ? "email/send" : "email/payment"
                                            })
                                        ]
                                    }));
                                    setVariant([
                                        "contained"
                                    ]);
                                    handleShowModal();
                                } else {
                                    setContent(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* default */.Z, {
                                        translations: translations,
                                        numberOfFreeNights: numberOfFreeNights,
                                        freeNightsCost: freeNightsCost,
                                        freeNightsOldPrice: freeNightsOldPrice,
                                        total: total,
                                        totalWithoutStripe: totalWithoutStripe,
                                        startDate: search.startDate.format("YYYY-MM-DD"),
                                        taxesAndFess: taxes,
                                        totalCostPerNights: price,
                                        endDate: search.endDate.format("YYYY-MM-DD"),
                                        propertyId: property === null || property === void 0 ? void 0 : property.resource_id,
                                        listingId: property === null || property === void 0 ? void 0 : property.id,
                                        bedrooms: bedroomOptions,
                                        property: property,
                                        guests: guests,
                                        bonuses: bonuses
                                    }));
                                    setVariant([
                                        "contained"
                                    ]);
                                    handleShowModal();
                                }
                            },
                            variant: [
                                expandable && !show && "full-width",
                                "gold"
                            ],
                            arrow: false,
                            children: translations.book[router.locale]
                        }),
                        (isTablet && !show || !isTablet) && loggedIn && (property === null || property === void 0 ? void 0 : (ref = property.attachment) === null || ref === void 0 ? void 0 : ref.rate_sheet) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            href: property.attachment.rate_sheet,
                            arrow: false,
                            target: "_blank",
                            appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {}),
                            variant: [
                                "label",
                                "m-t-xl"
                            ],
                            type: "button",
                            children: translations.download[router.locale]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var components_Reservation = (Reservation);

// EXTERNAL MODULE: ./public/icons/icon-favourite.svg
var icon_favourite = __webpack_require__(92562);
// EXTERNAL MODULE: ./public/icons/icon-share.svg
var icon_share = __webpack_require__(94954);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
;// CONCATENATED MODULE: ./public/icons/icon-expand-up.svg
var icon_expand_up_path;

function icon_expand_up_extends() { icon_expand_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_expand_up_extends.apply(this, arguments); }



const SvgIconExpandUp = props => /*#__PURE__*/react.createElement("svg", icon_expand_up_extends({
  viewBox: "0 0 21 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_expand_up_path || (icon_expand_up_path = /*#__PURE__*/react.createElement("path", {
  d: "M9.963.281 1.204 9.474a.825.825 0 0 0 0 1.138l.01.01a.759.759 0 0 0 1.1 0l8.248-8.657 8.244 8.657a.759.759 0 0 0 1.1 0l.01-.01a.825.825 0 0 0 0-1.138L11.157.28a.825.825 0 0 0-1.194 0Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_expand_up = (SvgIconExpandUp);
// EXTERNAL MODULE: ./components/elements/Dropdown/index.js
var Dropdown = __webpack_require__(44576);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/PinterestShareButton.js
var PinterestShareButton = __webpack_require__(61366);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__(48137);
// EXTERNAL MODULE: ./public/icons/icon-facebook.svg
var icon_facebook = __webpack_require__(30967);
// EXTERNAL MODULE: ./public/icons/icon-pinterest.svg
var icon_pinterest = __webpack_require__(34410);
// EXTERNAL MODULE: ./public/icons/icon-linkedin.svg
var icon_linkedin = __webpack_require__(89796);
// EXTERNAL MODULE: ./public/icons/icon-email.svg
var icon_email = __webpack_require__(95275);
// EXTERNAL MODULE: ./public/icons/icon-checkbox-check.svg
var icon_checkbox_check = __webpack_require__(73553);
// EXTERNAL MODULE: ./public/icons/icon-copy.svg
var icon_copy = __webpack_require__(31381);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(73985);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Estate/styles.module.scss
var Estate_styles_module = __webpack_require__(98479);
var Estate_styles_module_default = /*#__PURE__*/__webpack_require__.n(Estate_styles_module);
// EXTERNAL MODULE: ./components/custom/InquiryModal/index.js
var InquiryModal = __webpack_require__(54903);
// EXTERNAL MODULE: ./node_modules/lodash-es/startCase.js
var startCase = __webpack_require__(54003);
// EXTERNAL MODULE: ./providers/currencyProvider.js
var currencyProvider = __webpack_require__(4404);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Estate/index.js











var Estate = function(param) {
    var property = param.property, expandable = param.expandable, show = param.show, setShow = param.setShow, translations = param.translations, cardTranslations = param.cardTranslations;
    var ref = (0,modalProvider/* useModalContext */.vR)(), setContent = ref.setContent, handleShowModal = ref.handleShowModal, setVariant = ref.setVariant;
    var selectedCurrency = (0,currencyProvider/* useCurrencyContext */.VT)().selectedCurrency;
    var ref1 = (0,ResponsiveContext/* useResponsive */.F)(), isDesktop = ref1.isDesktop, isTablet = ref1.isTablet;
    var router = (0,next_router.useRouter)();
    var price = property.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isDesktop && !isTablet && show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                className: (Estate_styles_module_default()).form__button,
                type: "button",
                disabled: property === null || property === void 0 ? void 0 : property.sold,
                onClick: function() {
                    setShow(!show);
                },
                variant: [
                    expandable && !show && "full-width",
                    "gold"
                ],
                arrow: false,
                children: (property === null || property === void 0 ? void 0 : property.sold) ? "Sold" : "request more information"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details", [
                    isDesktop && expandable && show && "is-hidden"
                ], (Estate_styles_module_default())),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Estate_styles_module_default()).details__wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Estate_styles_module_default()).details__content,
                            children: [
                                property.interior && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Estate_styles_module_default()).details__row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: translations.interior[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (0,withComma/* withComma */.u)(property.interior.size),
                                                " ",
                                                (0,startCase/* default */.Z)(property.interior.measure)
                                            ]
                                        })
                                    ]
                                }),
                                property.exterior && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Estate_styles_module_default()).details__row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: translations.exterior[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (0,withComma/* withComma */.u)(property.exterior.size),
                                                " ",
                                                (0,startCase/* default */.Z)(property.exterior.measure)
                                            ]
                                        })
                                    ]
                                }),
                                property.land_size && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Estate_styles_module_default()).details__row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: translations.landsize[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (0,withComma/* withComma */.u)(property.land_size.size),
                                                " ",
                                                (0,startCase/* default */.Z)(property.land_size.measure)
                                            ]
                                        })
                                    ]
                                }),
                                !(property === null || property === void 0 ? void 0 : property.sold) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Estate_styles_module_default()).details__row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: translations.price[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((Estate_styles_module_default()).details__price, " ").concat((property === null || property === void 0 ? void 0 : property.price_upon_request) ? (Estate_styles_module_default()).details__default : ""),
                                            children: (property === null || property === void 0 ? void 0 : property.price_upon_request) ? cardTranslations.card.onRequest[router.locale] : "".concat(selectedCurrency.coin).concat(price[selectedCurrency.value])
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            variant: [
                                "full-width"
                            ],
                            arrow: false,
                            disabled: property === null || property === void 0 ? void 0 : property.sold,
                            onClick: function() {
                                setVariant([
                                    "contained"
                                ]);
                                setContent(/*#__PURE__*/ (0,jsx_runtime.jsx)(InquiryModal["default"], {
                                    translations: cardTranslations,
                                    name: property.propertyTitle || property.title,
                                    form: {
                                        title: property.propertyTitle || property.title
                                    }
                                }));
                                handleShowModal();
                            },
                            children: (property === null || property === void 0 ? void 0 : property.sold) ? translations.sold[router.locale] : translations.inquire[router.locale]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Estate = (Estate);

// EXTERNAL MODULE: ./node_modules/lodash-es/includes.js + 4 modules
var includes = __webpack_require__(67900);
// EXTERNAL MODULE: ./public/icons/icon-moon.svg
var icon_moon = __webpack_require__(59950);
// EXTERNAL MODULE: ./public/icons/icon-car.svg
var icon_car = __webpack_require__(35962);
// EXTERNAL MODULE: ./public/icons/icon-gift.svg
var icon_gift = __webpack_require__(96669);
// EXTERNAL MODULE: ./providers/favouritesProvider.js
var favouritesProvider = __webpack_require__(83155);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/index.js
































var Card = function(_param) {
    var isButtonDisabled = function isButtonDisabled() {
        if (property.is_active) {
            return !property.is_active;
        }
        if (isRealEstate && (property === null || property === void 0 ? void 0 : property.sold)) {
            return true;
        }
    };
    var _expandable = _param.expandable, expandable = _expandable === void 0 ? false : _expandable, _header = _param.header, header = _header === void 0 ? true : _header, property = _param.property, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, translations = _param.translations, cardTranslations = _param.cardTranslations, props = (0,_object_without_properties/* default */.Z)(_param, [
        "expandable",
        "header",
        "property",
        "variant",
        "translations",
        "cardTranslations"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,favouritesProvider/* useFavouritesContext */.H2)(), addOrRemoveFavourite = ref.addOrRemoveFavourite, isFavourite = ref.isFavourite;
    var isRealEstate = router.pathname.includes("real-estate");
    var ref1 = (0,ResponsiveContext/* useResponsive */.F)(), isDesktop = ref1.isDesktop, isTablet = ref1.isTablet, isSmallMobile = ref1.isSmallMobile;
    var ref2 = (0,react.useState)(expandable ? true : false), show = ref2[0], setShow = ref2[1];
    var ref3 = (0,react.useState)(0), width = ref3[0], setWidth = ref3[1];
    var ref4 = (0,react.useState)(0), loaded = ref4[0], setLoaded = ref4[1];
    var ref5 = (0,react.useState)(false), copied = ref5[0], setCopied = ref5[1];
    var ref6 = (0,react.useState)({
        car: false,
        night: false,
        gift: false
    }), bonuses = ref6[0], setBonuses = ref6[1];
    (0,react.useEffect)(function() {
        !show ? setWidth(200) : setWidth(0);
    }, [
        show
    ]);
    (0,react.useEffect)(function() {
        setLoaded(true);
    }, []);
    if (!loaded) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("card", [
            expandable && show && isDesktop && "collapsed",
            expandable && "welcome"
        ].concat((0,_to_consumable_array/* default */.Z)(variant)), (styles_module_default())),
        children: [
            isDesktop && expandable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setShow(!show);
                },
                className: (0,withModifiers/* withModifiers */.i)("card__expand", [
                    show && "is-rotated"
                ], (styles_module_default())),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_expand_up, {
                    width: isDesktop ? 13 : 21,
                    height: isDesktop ? 8 : 21
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).card__header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).card__intro,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    maxWidth: isDesktop ? width : "auto"
                                },
                                className: (styles_module_default()).card__details,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HouseDetails/* default */.Z, {
                                    variant: [
                                        "close"
                                    ],
                                    persons: (property === null || property === void 0 ? void 0 : property.bedrooms) ? (property === null || property === void 0 ? void 0 : property.bedrooms) * 2 : false,
                                    bathrooms: (property === null || property === void 0 ? void 0 : property.bathroom_no) || (property === null || property === void 0 ? void 0 : property.bathrooms),
                                    bedrooms: (property === null || property === void 0 ? void 0 : property.bedroom_no) || (property === null || property === void 0 ? void 0 : property.bedrooms)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).card__buttons,
                                children: [
                                    header && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                                // className={styles.card__heart}
                                                className: (0,withModifiers/* withModifiers */.i)("card__heart", [
                                                    isFavourite(property.id) && "is-active"
                                                ], (styles_module_default())),
                                                appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_favourite/* default */.Z, {
                                                    width: 17
                                                }),
                                                arrow: false,
                                                onClick: function() {
                                                    return addOrRemoveFavourite(property.id);
                                                },
                                                variant: [
                                                    "label",
                                                    "close"
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (styles_module_default()).card__label,
                                                    style: {
                                                        width: !isDesktop ? "auto" : !show ? 44 : 0
                                                    },
                                                    children: translations === null || translations === void 0 ? void 0 : translations.save[router.locale]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                                variant: [
                                                    "socials"
                                                ],
                                                buttonVariant: [
                                                    "close"
                                                ],
                                                appendIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_share/* default */.Z, {}),
                                                arrow: false,
                                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (styles_module_default()).card__label,
                                                    style: {
                                                        width: !isDesktop ? 56 : !show ? 55 : 0
                                                    },
                                                    children: translations === null || translations === void 0 ? void 0 : translations.share[router.locale]
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (styles_module_default()).card__socials,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                                            url: "".concat( true && (window === null || window === void 0 ? void 0 : window.location.href), "\n                "),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,withModifiers/* withModifiers */.i)("card__link", [
                                                                    "facebook"
                                                                ], (styles_module_default())),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_facebook/* default */.Z, {
                                                                    width: 16,
                                                                    height: 16
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                                                            url:  true && window.location.href,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,withModifiers/* withModifiers */.i)("card__link", [
                                                                    "linkedin"
                                                                ], (styles_module_default())),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_linkedin/* default */.Z, {
                                                                    width: 16,
                                                                    height: 16
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PinterestShareButton/* default */.Z, {
                                                            url:  true && window.location.href,
                                                            media:  true && window.location.href,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,withModifiers/* withModifiers */.i)("card__link", [
                                                                    "pinterest"
                                                                ], (styles_module_default())),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_pinterest/* default */.Z, {
                                                                    width: 17,
                                                                    height: 28
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailShareButton/* default */.Z, {
                                                            url:  true && window.location.href,
                                                            subject: translations.emailMessage[router.locale],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (styles_module_default()).card__link,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_email/* default */.Z, {
                                                                    width: 16,
                                                                    height: 16
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                                                            text:  true && window.location.href,
                                                            onCopy: function() {
                                                                setCopied(true);
                                                                setTimeout(function() {
                                                                    return setCopied(false);
                                                                }, 5000);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (styles_module_default()).card__link,
                                                                children: !copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                                                    classNames: "opacity",
                                                                    appear: true,
                                                                    timeout: {
                                                                        enter: 200,
                                                                        exit: 200
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_copy/* default */.Z, {
                                                                        width: 16,
                                                                        height: 16
                                                                    })
                                                                }, copied ? "fire" : "static") : /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                                                    classNames: "opacity",
                                                                    appear: true,
                                                                    timeout: {
                                                                        enter: 200,
                                                                        exit: 200
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_checkbox_check/* default */.Z, {
                                                                        width: 15,
                                                                        height: 13
                                                                    })
                                                                }, copied)
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    isSmallMobile && show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).card__label,
                                        style: {
                                            width: isSmallMobile ? "auto" : show ? 155 : 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            onClick: function() {
                                                return setShow(!show);
                                            },
                                            variant: [
                                                "xs",
                                                "color-accent"
                                            ],
                                            arrow: false,
                                            disabled: isButtonDisabled(),
                                            children: isRealEstate ? (property === null || property === void 0 ? void 0 : property.sold) ? translations.sold[router.locale] : translations.inquire[router.locale] : translations.book[router.locale]
                                        })
                                    }),
                                    isTablet && !isSmallMobile && show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).card__label,
                                        style: {
                                            width: !isRealEstate && (isSmallMobile ? "auto" : show ? 157 : 0)
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            onClick: function() {
                                                return setShow(!show);
                                            },
                                            variant: [
                                                "xs",
                                                "color-accent"
                                            ],
                                            arrow: false,
                                            disabled: isRealEstate && (property === null || property === void 0 ? void 0 : property.sold),
                                            children: isRealEstate ? (property === null || property === void 0 ? void 0 : property.sold) ? translations.sold[router.locale] : translations.inquire[router.locale] : translations.book[router.locale]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !isRealEstate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,withModifiers/* withModifiers */.i)("card__bonuses", [
                            (0,includes/* default */.Z)(bonuses, true) && (isDesktop ? !show && "is-shown" : "is-shown")
                        ], (styles_module_default())),
                        children: [
                            bonuses.car && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).card__bonus,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_car/* default */.Z, {}),
                                    translations.freeCar[router.locale]
                                ]
                            }),
                            bonuses.night && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).card__bonus,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_moon/* default */.Z, {}),
                                    translations.freeNight[router.locale]
                                ]
                            }),
                            bonuses.gift && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).card__bonus,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_gift/* default */.Z, {}),
                                    translations.freeGift[router.locale]
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).card__body,
                children: isRealEstate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Estate, {
                    expandable: expandable,
                    show: show,
                    setShow: setShow,
                    property: property,
                    cardTranslations: cardTranslations,
                    translations: translations
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Reservation, (0,_object_spread/* default */.Z)({
                    setBonuses: setBonuses,
                    show: show,
                    setShow: setShow,
                    property: property,
                    expandable: expandable,
                    bonuses: bonuses,
                    translations: translations
                }, props))
            })
        ]
    });
};
/* harmony default export */ var components_Card = (Card);


/***/ }),

/***/ 1962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30959);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34495);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27895);





var Perk = function(param) {
    var icon = param.icon, title = param.title, value = param.value, children = param.children, subtitle = param.subtitle, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__/* .withModifiers */ .i)("perk", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__icon),
                children: icon && typeof icon === "object" ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    width: 38,
                    height: 38,
                    alt: "icon ".concat(title),
                    src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__/* .getS3Url */ .v)(icon)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__title),
                        children: value
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: subtitle
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__description)
                    }),
                    children && children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Perk);


/***/ }),

/***/ 93019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51524);
/* harmony import */ var _elements_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50331);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17570);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40670);





var LoadingPage = function(param) {
    var _title = param.title, title = _title === void 0 ? "Loading" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? false : _subtitle, _spinner = param.spinner, spinner = _spinner === void 0 ? true : _spinner;
    var isTablet = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)().isTablet;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().page),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "-xs2"
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: subtitle
                }),
                spinner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().page__spinner),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: [
                            !isTablet && "xl",
                            "darker"
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LoadingPage);


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91298);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);


var Page = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3790), __webpack_require__.e(175), __webpack_require__.e(6820), __webpack_require__.e(8433), __webpack_require__.e(3817)]).then(__webpack_require__.bind(__webpack_require__, 51904));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51904)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Section = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5718)]).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Container = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 1524).then(__webpack_require__.bind(__webpack_require__, 51524));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51524)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5718)]).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});

var FourOhFour = function(param) {
    var headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, ctaTranslation = param.ctaTranslation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, {
        ctaTranslation: ctaTranslation,
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        meta: {
            title: "404 - Error Page | St. Martin Sotheby's Realty",
            description: "404 - Error Page | St. Martin Sotheby's Realty"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {
            variant: [
                "center"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__title),
                            children: "Sorry, no page found"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__separator)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__description),
                            children: "WE COULDN’T FIND WHAT YOU’RE LOOKING FOR"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            href: "/vacation-rentals",
                            arrow: false,
                            children: "browse our properties"
                        })
                    ]
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (FourOhFour);


/***/ }),

/***/ 42006:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__gIdbr","gallery__image":"styles_gallery__image__1du1y","gallery__grid":"styles_gallery__grid__B3TT1","gallery__item":"styles_gallery__item__Uf0Ys","gallery--xs":"styles_gallery--xs__zDe6b","gallery--white":"styles_gallery--white__9p75m","gallery--has-separator":"styles_gallery--has-separator__HA_Fv","gallery--has-button":"styles_gallery--has-button__amFIX"};

/***/ }),

/***/ 17423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__pjXty","description":"styles_description__DvmBX"};

/***/ }),

/***/ 5963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__knGxi","note":"styles_note__MeUqr","nights":"styles_nights__4TL7m","calendar":"styles_calendar__AsY2r","calendar__button":"styles_calendar__button__rz_AK","booking":"styles_booking__5O1lg","booking--is-visible":"styles_booking--is-visible__JsDWf","wrapper":"styles_wrapper__4ug9Z"};

/***/ }),

/***/ 75885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__pD1mn","section":"styles_section__grUyC","fixed":"styles_fixed__0M0DB","content":"styles_content__lw_aq"};

/***/ }),

/***/ 14192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"city":"styles_city__7UP4c","slider":"styles_slider__EPL7B","slider__gallery":"styles_slider__gallery__NdY0C","slider__arrow":"styles_slider__arrow__nzfFA","slider__arrow--left":"styles_slider__arrow--left__l_v83"};

/***/ }),

/***/ 65792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__cIkEc"};

/***/ }),

/***/ 30410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__hvozo","intro__button":"styles_intro__button__gnliW","intro__divider":"styles_intro__divider__M5ISP","intro__title":"styles_intro__title__eDLi_","intro__more":"styles_intro__more__dzMEH","intro__column":"styles_intro__column__GRAe_","intro__description":"styles_intro__description__rDqnd","intro__description--is-visible":"styles_intro__description--is-visible__0HRwO","intro__icon":"styles_intro__icon__jMC24","intro__icon--up":"styles_intro__icon--up__j2qLW","name":"styles_name__tEeA0"};

/***/ }),

/***/ 98925:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__q4qlr","map--full-width":"styles_map--full-width__qJPbm","map__marker":"styles_map__marker__qjYlo","section":"styles_section__nJUaP"};

/***/ }),

/***/ 63405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"welcome":"styles_welcome__EWCGy","welcome__image":"styles_welcome__image__xoEKb","welcome__image--grayscale":"styles_welcome__image--grayscale__oq6D5","welcome__content":"styles_welcome__content__HvHDf","welcome__left":"styles_welcome__left__gXlDY","welcome__details":"styles_welcome__details__UyZ_u","welcome__promo":"styles_welcome__promo__i_Ff_","welcome__paragraph":"styles_welcome__paragraph__ALm1S","welcome__description":"styles_welcome__description__fojzP","welcome__tag":"styles_welcome__tag__sY1fC","welcome__title":"styles_welcome__title__LBl5d"};

/***/ }),

/***/ 98479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__Cserm","details--is-hidden":"styles_details--is-hidden__tg67D","details__content":"styles_details__content__6rW90","details__row":"styles_details__row__iWb1I","details__price":"styles_details__price__zL1mU","details__default":"styles_details__default__NTZh9"};

/***/ }),

/***/ 9337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radios":"styles_radios__TGFYp"};

/***/ }),

/***/ 3542:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radios":"styles_radios__v46aB"};

/***/ }),

/***/ 42450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formik":"styles_formik__5RkgX","form":"styles_form__PCxQ3","form__button":"styles_form__button__KWAjz","form--is-hidden":"styles_form--is-hidden__JcfBu","form__pricing":"styles_form__pricing__41bh2","form__nights":"styles_form__nights__Q8yX2","form__number":"styles_form__number__M_DcY","form__title":"styles_form__title__tdfeN","form__subtitle":"styles_form__subtitle__eqObR","form__row":"styles_form__row__tXaJS"};

/***/ }),

/***/ 52400:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__9836K","card__intro":"styles_card__intro__A8k8c","card__bonuses":"styles_card__bonuses__JUZrO","card__bonuses--is-shown":"styles_card__bonuses--is-shown__wTBw7","card__bonus":"styles_card__bonus__qwVzT","card__header":"styles_card__header__J67QF","card__details":"styles_card__details__mGHsS","card__buttons":"styles_card__buttons__svTNT","card__label":"styles_card__label__1e6k2","card__socials":"styles_card__socials__l1Wm3","card__link":"styles_card__link__PHsEi","card__link--facebook":"styles_card__link--facebook__nANci","card__link--linkedin":"styles_card__link--linkedin__rLOCb","card__link--pinterest":"styles_card__link--pinterest__VPjSQ","card__copy":"styles_card__copy__0VsG2","card__heart":"styles_card__heart__93_zE","card__heart--is-active":"styles_card__heart--is-active__6QfsO","card__body":"styles_card__body___jc5d","card__expand":"styles_card__expand__49qOy","card__expand--is-rotated":"styles_card__expand--is-rotated__JvHi0","card--welcome":"styles_card--welcome__FoGCq","card--simple":"styles_card--simple__op9pQ","card--collapsed":"styles_card--collapsed__7Xxpt"};

/***/ }),

/***/ 30959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perk":"styles_perk__aYDiO","perk__icon":"styles_perk__icon__9_PGC","perk__title":"styles_perk__title__wwvP5","perk--spacing-xs":"styles_perk--spacing-xs__knH3y","perk--accent":"styles_perk--accent__GH2LI","perk__description":"styles_perk__description__uG0rQ","perk--title-color-dark":"styles_perk--title-color-dark__eY0DF","perk--style-inverted":"styles_perk--style-inverted__MCh15","perk--large":"styles_perk--large__OH1me"};

/***/ }),

/***/ 17570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__NPbYR","page__spinner":"styles_page__spinner__MIrmj"};

/***/ }),

/***/ 91298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__hoAMN","content__title":"styles_content__title__t_t8G","content__description":"styles_content__description__3suem","content__separator":"styles_content__separator__BUjYs"};

/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 35242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_pull; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseRest.js
var _baseRest = __webpack_require__(69581);
// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(74073);
// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIndexOf.js + 3 modules
var _baseIndexOf = __webpack_require__(36333);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOfWith.js
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseIndexOfWith = (baseIndexOfWith);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(21162);
// EXTERNAL MODULE: ./node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__(87215);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAll.js






/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf/* default */.Z,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = (0,_copyArray/* default */.Z)(values);
  }
  if (iteratee) {
    seen = (0,_arrayMap/* default */.Z)(array, (0,_baseUnary/* default */.Z)(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ var _basePullAll = (basePullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pullAll.js


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

/* harmony default export */ var lodash_es_pullAll = (pullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pull.js



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = (0,_baseRest/* default */.Z)(lodash_es_pullAll);

/* harmony default export */ var lodash_es_pull = (pull);


/***/ }),

/***/ 54003:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createCompounder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53683);
/* harmony import */ var _upperFirst_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43880);



/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = (0,_createCompounder_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(result, word, index) {
  return result + (index ? ' ' : '') + (0,_upperFirst_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(word);
});

/* harmony default export */ __webpack_exports__["Z"] = (startCase);


/***/ })

}]);